/* ============================================================================
   Mon Chou — Self-owned Product Personalizer (replaces Zepto Product Personalizer)

   Consumes the product's harvested cstmfy config verbatim (see
   docs/audit/zepto-configs/CSV-SCHEMA.md) so previews and order line-item
   properties are byte-for-byte identical to the previous app.

   Config injection (from snippets/mc-personalizer.liquid):
     window.__MC_PERSONALIZER = {
       productId, canvasSize, prodata, metas: [csvString, ...],
       assetBase,   // theme asset base URL for fonts/preview-images
       labels: {...},          // locale-resolved UI strings
       surcharge: { variantId, refPrefix } | null,  // Hånskrift/Tegning companion
       formSelector: 'form[action*="/cart/add"]'
     }

   Field types supported (all Mon Chou uses): 1=text single-font,
   2=text with font-variant metas, 3=file upload (+crop), 6=dropdown/ghost.

   Property rules (MUST NOT CHANGE — fulfillment/DXF/CS depend on them):
   - text field:      properties[<propKey>]      e.g. properties['ABC'], ♀, ♂, 1, 2
   - font choice:     properties[🖊️]; 2nd+ field gets ' 🖊️' (leading spaces)
   - upload:          properties[Billede] (file) + properties[_Billede_crop] (file)
   - preview:         properties[Vis smykke] (file) + properties[_pplr_preview]='Vis smykke'
   - surcharge link:  properties[_pc_pricing_ref], properties[_pc_pricing_qty_split]
   ========================================================================== */
(function () {
  'use strict';
  var CFG = window.__MC_PERSONALIZER;
  if (!CFG || window.__mcPersonalizerActive) return;
  window.__mcPersonalizerActive = true;

  /* ---------- tuning flags (Jonas' review 2026-09-04, rounds 1-3) ----------
     Each fix is independently switchable so a regression can be killed with
     one console flag (window.__MC_TUNE) without a redeploy. Read at DRAW time,
     so flipping + re-render shows the change live (test/ab.html relies on it).
       symbolNormalize : strip VS15/VS16 before LAYOUT ONLY (never the order
                         property) so U+2665+VS16 uses the house-font glyph,
                         not the OS colour-emoji face (9 red-heart orders)
       symbolBearings  : minimum side-bearing for symbols/separators against
                         letters + emoji ink centred in its advance cell
       elegantBoost    : Elegant at x1.12 nominal - optical parity with
                         Moderne, whose FONT_SIZE_ADJUST is already 1.14
                         (review: 60x 'bigger', 0x 'smaller' on Elegant)
       fontRaceFix     : ATC waits for the real repaint instead of 200ms  */
  (function () {
    var st = document.createElement('style');
    st.setAttribute('data-mc', 'rich-field');
    st.appendChild(document.createTextNode(
      '.mc-rich-field{white-space:pre;overflow-x:auto;overflow-y:hidden;cursor:text;-webkit-user-modify:read-write-plaintext-only;}' +
      '.mc-rich-field:empty::before{content:attr(data-placeholder);color:#b9b0a4;pointer-events:none;}' +
      '.mc-rich-field span{display:inline;}'));
    (document.head || document.documentElement).appendChild(st);
  })();
  var TUNE = { symbolNormalize: true, symbolBearings: true, elegantBoost: 1.12, fontRaceFix: true,
    /* rev3 (Jonas' par-numre 2026-09-05): Moderne-flerlinje en anelse ned (K1) */
    moderneMultiScale: 0.94,
    /* rev4: skrivefeltet viser samme glyffer som smykket - vaerdien normaliseres
       ved indtastning (VS16 vaek, solid hjerte/uendelig -> kontur), saa felt,
       preview, ordre-egenskab og gravoer ser praecis samme tegn */
    inputNormalize: true,
    /* rev4b: kun aegte pictographs stroke-forstaerkes; husets BMP-symboler
       (hjerter, uendelig) beholder bogstavernes stregvaegt (kill-switch: true) */
    strokeBmpSymbols: false,
    /* rev5: skrivefeltet bruger samme afstands-regler som smykket - symboler
       og Elegant-versalpar faar luft OGSAA i feltet (contenteditable-spejl;
       det skjulte input forbliver property-baerer og kortvaelgerens maal) */
    richField: true,
    /* rev6 (Jonas: 11 vs 12 tegn): bloed overgang ved breddeloftet - knib
       bogstavafstanden op til 3% FOER stoerrelsen skaleres, saa en linje der
       kun lige tipper over loftet beholder samme bogstavstoerrelse */
    softTracking: 0,
    /* rev7 (Jonas '\u266129.09.09\u2661'): OPTISK spatiering af symboler - oejet
       aflaeser LUFTAREALET mellem to figurer, ikke naermeste afstand. '\u26612' har
       vigende konturer (stort areal ved samme min-afstand), '9\u2661' fyldige
       former over for hinanden (lille areal). Reglen: udlign GENNEMSNITS-
       luften glyf-profil mod glyf-profil, med en lille min-afstand som gulv -
       det haandgravoerer goer i haanden. */
    opticalSpacing: false,
    /* rev9 (Jonas): bar-armbaand centreres paa BLAEKKET - tekstens faktiske
       hoejeste og laveste punkt laegges praecis midt mellem feltets top og
       bund, saa lave bogstaver ('anne') og hoeje ('Nj') hver centreres rigtigt */
    inkVCenter: true,
    /* 3.81 (Jonas 2026-10-18): Elegant's space glyph is 0.41em wide - 1.6x
       Moderne's 0.25em - so 'A + B' / 'Anna ♡ Jonas' got gaping holes
       around the symbol. A typed space NEXT TO A SYMBOL now counts this
       fraction of its width in Elegant (0.6 -> 0.25em, Moderne's space).
       Word spaces between letters are untouched. 1 = old behaviour. */
    elegantSymbolSpace: 0.6,
    /* rev3 pr.-produkt-finjustering: wScale klemmer bredde-loftet ind fra
       pladekanten (P01/P02), hClamp holder descendere inde i feltboksen (P03),
       dy flytter blokken ned mod optisk midte (px @600 - P05/P13/K2),
       boost:false fritager Elegant-forstoerrelsen (P05, soleil rund) */
    fit: {
      /* rev4 (Jonas): INGEN stoerrelsesaendring paa bar-armbaandene - kun
         luft/afstand. 5mm-pladen redder descenderen ved at LOEFTE linjen. */
      '10245138448725': { hLift: 1, boost: false, vInk: 1 },
      /* Elegant-boost fritaget paa alle bar-plader - stoerrelsen skal matche
         det publicerede tema; kun luft/afstand aendres (Jonas rev5) */
      '8957279994197': { boost: false, vInk: 1 }, '8957280452949': { boost: false, vInk: 1 },
      '8957287727445': { boost: false, vInk: 1 }, '9923632169301': { boost: false, vInk: 1 },
      '9924919066965': { boost: false, vInk: 1 }, '8957279535445': { boost: false, vInk: 1 },
      '8957278978389': { boost: false, vInk: 1 }, '7518190633159': { boost: false, vInk: 1 },
      '7525641650375': { boost: false, vInk: 1 }, '7560828059847': { boost: false, vInk: 1 },
      '7560829698247': { boost: false, vInk: 1 }, '7560830124231': { boost: false, vInk: 1 },
      '8926277009749': { dy: 6, boost: false },
      '8761384763733': { dy: 7 }
    } };
  (function () { var o = window.__MC_TUNE; if (o) for (var k in o) TUNE[k] = o[k]; })();
  window.__mcTune = TUNE;

  /* ---------- cstmfy CSV decoding (schema: CSV-SCHEMA.md) ---------- */
  function decodeMeta(csv) {
    var c = csv.split(',');
    function s(i) { return (c[i] || '').trim(); }
    function f(i, d) { var v = parseFloat(c[i]); return isNaN(v) ? d : v; }
    // property keys must keep leading/trailing whitespace EXACTLY
    // (e.g. 'Indvendig indgravering ' has a trailing space in real orders)
    var label = decodeHtml(c[8] || '');
    var prop = (f(75, 0) > 0 && (c[76] || '') !== '') ? c[76]
      : label.replace(/\\/g, '').replace(/\//g, '').replace(/"/g, "'");
    return {
      font: mcFont(s(0).split('/').pop()),
      size: f(1, 16), x: f(2, 50), y: f(3, 50), w: f(4, 30),
      spacing: f(5, 0),
      color: s(6) || '#8c603b',
      maxLines: Math.max(1, f(7, 1)),
      label: label,
      placeholderDefault: decodeHtml(s(9)),
      typeCode: s(10),
      angle: f(11, 0),
      alpha12: f(12, NaN),   // Zepto text opacity: alpha = 1 - col12/127
      inputType: s(13),
      ratio: f(14, 1),
      maxChars: f(17, 30),
      baseImage: s(18).split('/').pop(),
      fontCase: s(19),
      align: s(20) || 'center',
      crop: s(22),
      state23: s(23),
      // col24 font key BYTE-EXACT — spaces are significant: veninde-halskæder
      // use '🖊️ ' (trailing) for field 1, kæreste ' 🖊️' (leading) for field 2
      // (validated against orders #25145/#25148/#25153/#25160)
      fontProp: decodeHtml(c[24] || ''),
      priceAdd: f(27, 0),
      // line distance EXACTLY 1 for every product (Jonas 2026-07-07) — col28's
      // per-product multipliers (1.2-1.45) are ignored; the editor's
      // lineHeight override still applies on top for per-product tuning
      lineHeight: 1,
      valign: s(30),
      minW: f(32, 0), minH: f(33, 0),
      fontGroupName: s(34),  // fontgroup_json key; '1' = none (fheight 1)
      placeholder: decodeHtml(s(55)),
      prop: prop,
      raw: c
    };
  }
  function decodeHtml(str) {
    if (!str || str.indexOf('&') === -1) return str || '';
    var t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }

  /* ---------- grapheme counting (Zepto counts emoji/ZWJ sequences as 1) ---- */
  var SEGMENTER = (typeof Intl !== 'undefined' && Intl.Segmenter)
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
  function graphemes(str) {
    if (!str) return [];
    if (SEGMENTER) {
      var out = [];
      var it = SEGMENTER.segment(str)[Symbol.iterator]();
      for (var r = it.next(); !r.done; r = it.next()) out.push(r.value.segment);
      return out;
    }
    return Array.from(str); // code points — ZWJ sequences count >1, acceptable fallback
  }
  // Zepto limitTextarea: greedy grapheme word-wrap into <= maxLines lines of
  // <= perLine graphemes each; overlong words hard-chunked; excess dropped.
  function clampMultiline(value, perLine, maxLines) {
    var out = [];
    var paras = value.split('\n');
    for (var p = 0; p < paras.length && out.length < maxLines; p++) {
      var words = paras[p].split(' ');
      var line = '';
      for (var w = 0; w < words.length; w++) {
        var word = words[w];
        var candidate = line ? line + ' ' + word : word;
        if (graphemes(candidate).length <= perLine) { line = candidate; continue; }
        if (line) {
          out.push(line);
          line = '';
          if (out.length >= maxLines) break;
        }
        var g = graphemes(word);
        while (g.length > perLine && out.length < maxLines - 1) {
          out.push(g.slice(0, perLine).join(''));
          g = g.slice(perLine);
        }
        line = g.slice(0, perLine).join('');
      }
      if (out.length < maxLines) out.push(line);
    }
    return out.join('\n');
  }

  /* ---------- group metas into fields ---------- */
  function buildFields(metas) {
    var fields = [], byProp = {};
    var autoNum = 0;
    metas.forEach(function (m) {
      if (m.inputType === '6' && m.state23 === '2') {
        // ghost/display-only layer (e.g. monogram 'A B C' placeholder) — render only
        fields.push({ kind: 'ghost', variants: [m], prop: null });
        return;
      }
      if (m.inputType === '3') {
        fields.push({ kind: 'upload', variants: [m], prop: m.prop || 'Billede' });
        return;
      }
      if (m.inputType === '6') {
        fields.push({ kind: 'select', variants: [m], prop: m.prop });
        return;
      }
      // text field (types 1/2). Same prop repeated:
      //  - different font files → FONT variants (e.g. hjerteformet Moderne/Elegant)
      //  - same font file → POSITION variants driven by a select (e.g. Bangle
      //    Udvendig/Indvendig layouts of 'ABC')
      var key = m.prop;
      if (!key) { autoNum += 1; key = String(autoNum); m.prop = key; }
      if (byProp[key]) {
        var fld0 = byProp[key];
        fld0.variantsKind = (m.font === fld0.variants[0].font) ? 'position' : 'font';
        fld0.variants.push(m);
        return;
      }
      var fld = { kind: 'text', prop: key, variants: [m], variantsKind: null };
      byProp[key] = fld;
      fields.push(fld);
    });
    return fields;
  }

  /* ---------- fonts ---------- */
  // Jonas 2026-07-06: production faces WITH monochrome emoji glyphs replace
  // the legacy files. Metrics are byte-identical to Mc-moderne-extended/A67
  // (the newest Zepto config already used those), so cirkel-m-zirkoner-solv
  // renders unchanged; legacy Helvetica-light/Elegant-2 products shift
  // slightly (Moderne ~9% narrower, Elegant ~16% wider) — approved direction.
  var FONT_REMAP = {
    'Helvetica-light-587ebe5a59211.ttf': 'Moderne-Emoji.otf',
    'Mc-moderne-extended.ttf': 'Moderne-Emoji.otf',
    'Elegant-2.ttf': 'Elegant-Emoji.otf',
    'A67.ttf': 'Elegant-Emoji.otf'
  };
  function mcFont(file) { return FONT_REMAP[file] || file; }
  // visual size harmonization (Jonas): Moderne's lowercase reads much smaller
  // than Elegant at equal pss — boost so x-heights match (0.461 vs 0.483em ×
  // group scales 1.1/1.18 → ×1.14 equalizes)
  var FONT_SIZE_ADJUST = { 'Moderne-Emoji.otf': 1.14 };
  // per-font engraving tone: the Elegant connected script reads darker and
  // harder than Moderne at the same settings — lighten its ink COLOR toward
  // Moderne's soft look, ALL products. Color only, opacities untouched
  // (Jonas 2026-07-07 round 2: 'don't change the opacity, just the color').
  var FONT_TONE = { 'Elegant-Emoji.otf': { lighten: 0.25 } };
  function lightenColor(hex, f) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return hex;
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return 'rgb(' + Math.round(r + (255 - r) * f) + ',' +
                    Math.round(g + (255 - g) * f) + ',' +
                    Math.round(b + (255 - b) * f) + ')';
  }
  var fontFamilies = {}; // file -> family name
  // font group (Zepto fontgroup_json): {Moderne:[file,scale,offset,enabled],...}
  var FONT_GROUP = (CFG.fontGroups && (CFG.fontGroups.FONTS || CFG.fontGroups.Skrifttype)) || null;
  function loadFonts(fields) {
    var files = {};
    fields.forEach(function (f) {
      f.variants.forEach(function (v) { if (v.font) files[v.font] = 1; });
    });
    if (FONT_GROUP) Object.keys(FONT_GROUP).forEach(function (n) { files[mcFont(FONT_GROUP[n][0])] = 1; });
    // Load via injected @font-face CSS (more lenient than the FontFace API for
    // legacy converted TTFs, e.g. the Helvetica Light file) + explicit
    // document.fonts.load so the canvas never falls back to a serif silently.
    var css = '';
    Object.keys(files).forEach(function (file) {
      var fam = 'mc-' + file.replace(/\.[^.]+$/, '').replace(/[^a-zA-Z0-9-]/g, '');
      fontFamilies[file] = fam;
      // versioned URL from liquid (asset_url ?v=) so a repaired font is never
      // shadowed by the stale copy at the CDN edge; bare assetBase = fallback
      var url = CFG.fontUrls && CFG.fontUrls[file];
      if (!url) {
        // the fallback was UNVERSIONED -> a repaired font stays shadowed by a
        // stale CDN-edge copy (suspected cause of the rare 'E lla' capital
        // gap, orders #26788/#26881). Bust it, and surface the map gap.
        url = CFG.assetBase + file + (CFG.assetBase.indexOf('?') < 0 ? '?v=' : '&v=') + (CFG.assetVer || '20260905');
        if (window.console) console.warn('[mc-personalizer] font missing from fontUrls (cache-busted):', file);
      }
      // detect format from the URL, not the map key — the production fonts
      // keep their .otf keys but serve WOFF2 conversions (perf round)
      var fmt = /\.woff2(\?|$)/i.test(url) ? 'woff2'
              : /\.otf$/i.test(file) ? 'opentype' : 'truetype';
      css += '@font-face{font-family:"' + fam + '";src:url("' + url +
        '") format("' + fmt + '");font-display:swap;}\n';
    });
    var st = document.createElement('style');
    st.setAttribute('data-mc', 'personalizer-fonts');
    st.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(st);
    return Promise.all(Object.keys(files).map(function (file) {
      return document.fonts.load('16px "' + fontFamilies[file] + '"').then(function (loaded) {
        if (!loaded.length && window.console) console.warn('[mc-personalizer] font failed:', file);
        return loaded;
      }).catch(function () {});
    }));
  }


  // MC speed 3.2 (F6): the two production faces (~190KB woff2 each) used to be
  // <head>-preloaded on every PDP view. They now load on the customer's first
  // engagement with the product form (or immediately when content is prefilled).
  // fontsReadyDone gates BOTH the preview text pass and the ATC snapshot, so
  // neither the on-page preview nor the engraver-facing PNG can ever rasterize
  // in a fallback font.
  var fontsReadyP = null, fontsReadyDone = false, mcFontWait = false;
  function ensureFontsLoaded() {
    if (!fontsReadyP) {
      fontsReadyP = loadFonts(fields).then(function (r) { fontsReadyDone = true; applyDomFonts(); return r; });
    }
    return fontsReadyP;
  }
  // Re-apply the custom faces to the DOM (engraving input + font chips) in one
  // controlled pass after the deferred load resolves — buildUI ran before
  // fontFamilies existed, so these elements start on the Helvetica fallback.
  function applyDomFonts() {
    fields.forEach(function (f) {
      if (!f.fontOptions) return;
      var idx = state.fontChoice[f.prop] || 0;
      if (f._applyInputFont && f.fontOptions[idx]) f._applyInputFont(f.fontOptions[idx]);
      if (f._fontItems) f._fontItems.forEach(function (it, i) {
        var o = f.fontOptions[i];
        if (o) it.style.fontFamily = (fontFamilies[o.file] ? '"' + fontFamilies[o.file] + '", ' : '') + 'Helvetica, Arial, sans-serif';
      });
    });
  }


  /* ---------- state ---------- */
  var state = { values: {}, fontChoice: {}, uploadFile: null, cropBlob: null, noEngraving: false };
  window.__mcState = state; // introspection for tests/support (no PII beyond current inputs)
  // metas may arrive later via asset-config fetch (see boot()) — guard the map
  var fields = (CFG.metas && CFG.metas.length) ? buildFields(CFG.metas.map(decodeMeta)) : [];
  var CANVAS = CFG.canvasSize || 600;
  var form = document.querySelector(CFG.formSelector || 'form[action*="/cart/add"]');

  /* ---------- i18n ---------- */
  var L = CFG.labels || {};
  function t(k, dflt) { return L[k] || dflt; }

  /* ---------- emoji keyboard (exact Zepto set) ---------- */
  var EMOJIS = ['♡','☆','☼','☽','✓','♪','∞','♂','♀','+','🫶','😊','😘','💋','💘','🙏','🌹','🌸','✨','🦋','🕊️','🐬','🐱','🐶','🐵','🐾','🍀','❄️','⚡','🌎','⚓','💎','🔑','🔐','🧩','🎓','🥇','🏆','🚀','💰','🔥'];
  var SMILEY_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="60" stroke-dashoffset="60" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.5s" values="60;0"/></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 14C8.5 15.5 9.79086 17 12 17C14.2091 17 15.5 15.5 16 14"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1s" dur="0.2s" values="14;0"/></path></g><g fill="currentColor" fill-opacity="0"><ellipse cx="9" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.6s" dur="0.2s" values="0;1"/></ellipse><ellipse cx="15" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.8s" dur="0.2s" values="0;1"/></ellipse></g></svg>';

  /* ---------- UI build ---------- */
  var root, previewCanvas, previewCtx, baseImg = null, baseImgFile = '', previewBtn = null;
  function el(tag, cls, parent) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (parent) parent.appendChild(n);
    return n;
  }

  // Customer-facing property keys (Jonas 2026-07-06; localized per storefront
  // language 2026-07-12): 'ABC' → Gravering/Gravyr/Gravur/Gravure/Engraving,
  // 🖊️ → Skrifttype/Typsnitt/Schriftart/Police/Font, upload 'Billede' →
  // Billede/Bild/Image, preview 'Vis smykke' → local name. Space placement is
  // preserved (duplicate-key disambiguation, e.g. ' Skrifttype' for the
  // second field). Internal lookups (configs, overrides, state, and the
  // '_Billede_crop' file) still use the original f.prop; only SUBMITTED names
  // change. Downstream (DXF/CS/copy button) accepts legacy Zepto, English AND
  // localized generations — docs/property-keys.md is the source of truth.
  var MC_LANG = (document.documentElement.getAttribute('lang') ||
    (window.Shopify && Shopify.locale) || 'da').slice(0, 2).toLowerCase();
  var MC_KEYS = ({
    da: { text: 'Gravering', font: 'Skrifttype', image: 'Billede', preview: 'Vis smykke' },
    sv: { text: 'Gravyr',    font: 'Typsnitt',   image: 'Bild',    preview: 'Visa smycket' },
    de: { text: 'Gravur',    font: 'Schriftart', image: 'Bild',    preview: 'Schmuck ansehen' },
    fr: { text: 'Gravure',   font: 'Police',     image: 'Image',   preview: 'Voir le bijou' },
    en: { text: 'Engraving', font: 'Font',       image: 'Image',   preview: 'View jewelry' },
    pl: { text: 'Grawer',    font: 'Czcionka',   image: 'Zdjęcie', preview: 'Zobacz biżuterię' },
    nl: { text: 'Gravering', font: 'Lettertype', image: 'Afbeelding', preview: 'Bekijk sieraad' }
  })[MC_LANG] || { text: 'Engraving', font: 'Font', image: 'Image', preview: 'View jewelry' };
  function mcPropKey(key) {
    return String(key).replace("'ABC'", MC_KEYS.text).replace('🖊️', MC_KEYS.font);
  }
  function mcImageKey(prop) { return prop === 'Billede' ? MC_KEYS.image : prop; }

  // "Order without engraving" (Jonas 2026-08-01). An empty engraving used to be
  // a dead end ("Udfyld venligst din indgravering"); it now offers a checkbox.
  // The submitted VALUE is localized — unlike font names / 'Coordinates', which
  // are identifiers, this string is customer-facing on the cart line, in
  // checkout and in the order confirmation. Machine readers must key off the
  // hidden, language-neutral '_No engraving' marker instead (docs/property-keys.md).
  var MC_NOENG_ALL = {
    da: {
      value: 'Uden gravering',
      ask: 'Du har ikke tilføjet en gravering. Vil du bestille uden gravering?',
      label: 'Ja tak – bestil uden gravering',
      done: 'Du kan nu lægge varen i kurven.'
    },
    sv: {
      value: 'Utan gravyr',
      ask: 'Du har inte lagt till någon gravyr. Vill du beställa utan gravyr?',
      label: 'Ja tack – beställ utan gravyr',
      done: 'Du kan nu lägga varan i varukorgen.'
    },
    de: {
      value: 'Ohne Gravur',
      ask: 'Du hast keine Gravur hinzugefügt. Möchtest du ohne Gravur bestellen?',
      label: 'Ja – ohne Gravur bestellen',
      done: 'Du kannst den Artikel jetzt in den Warenkorb legen.'
    },
    fr: {
      value: 'Sans gravure',
      ask: 'Vous n’avez pas ajouté de gravure. Souhaitez-vous commander sans gravure ?',
      label: 'Oui – commander sans gravure',
      done: 'Vous pouvez maintenant ajouter l’article au panier.'
    },
    en: {
      value: 'Without engraving',
      ask: 'You haven’t added an engraving. Would you like to order without engraving?',
      label: 'Yes – order without engraving',
      done: 'You can now add the item to your cart.'
    },
    pl: {
      value: 'Bez grawerunku',
      ask: 'Nie dodano grawerunku. Czy chcesz zamówić bez grawerunku?',
      label: 'Tak – zamów bez grawerunku',
      done: 'Możesz teraz dodać produkt do koszyka.'
    },
    nl: {
      value: 'Zonder gravering',
      ask: 'Je hebt geen gravering toegevoegd. Wil je zonder gravering bestellen?',
      label: 'Ja – bestel zonder gravering',
      done: 'Je kunt het product nu in je winkelwagen leggen.'
    }
  };
  var MC_NOENG = MC_NOENG_ALL[MC_LANG] || MC_NOENG_ALL.en;

  // 3.82: customer-facing error lines (the upload check used a Danish alert on
  // every market; the new cases below had no message at all)
  var MC_MSG = ({
    da: { small: 'Billedet er for lille — mindst {w}x{h} pixels.', unreadable: 'Billedet kunne ikke åbnes. Prøv venligst et JPG- eller PNG-billede (fx et skærmbillede).', failed: 'Noget gik galt. Prøv venligst igen.' },
    sv: { small: 'Bilden är för liten — minst {w}x{h} pixlar.', unreadable: 'Bilden kunde inte öppnas. Försök med en JPG- eller PNG-bild (t.ex. en skärmdump).', failed: 'Något gick fel. Försök igen.' },
    de: { small: 'Das Bild ist zu klein — mindestens {w}x{h} Pixel.', unreadable: 'Das Bild konnte nicht geöffnet werden. Bitte versuche ein JPG- oder PNG-Bild (z. B. einen Screenshot).', failed: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.' },
    fr: { small: 'L’image est trop petite — au moins {w}x{h} pixels.', unreadable: 'L’image n’a pas pu être ouverte. Essayez une image JPG ou PNG (par ex. une capture d’écran).', failed: 'Une erreur est survenue. Veuillez réessayer.' },
    en: { small: 'The image is too small — at least {w}x{h} pixels.', unreadable: 'The image could not be opened. Please try a JPG or PNG image (e.g. a screenshot).', failed: 'Something went wrong. Please try again.' }
  })[MC_LANG] || null;
  if (!MC_MSG) MC_MSG = { small: 'The image is too small — at least {w}x{h} pixels.', unreadable: 'The image could not be opened. Please try a JPG or PNG image (e.g. a screenshot).', failed: 'Something went wrong. Please try again.' };

  function fontPropName(index) {
    // 1st font field: 🖊️ ; 2nd: ' 🖊️' ; 3rd: '  🖊️' — matches Zepto dedup behavior
    // (index is 1-based: index=2 → exactly one leading space, per real order data)
    return new Array(index).join(' ') + '🖊️';
  }

  function buildUI() {
    root = el('div', 'product-personalizer mc-personalizer pplr_background');
    var mount = document.querySelector('[data-mc-personalizer-mount]') || form || document.body;
    // insert before the ATC button's top-level ancestor inside mount
    // (in real themes the button is nested; insertBefore needs a direct child)
    var btn0 = mount.querySelector('button[type="submit"], [name="add"]');
    var anchor = null;
    if (btn0) {
      anchor = btn0;
      while (anchor.parentElement && anchor.parentElement !== mount) anchor = anchor.parentElement;
    }
    if (anchor && anchor.parentElement === mount) mount.insertBefore(root, anchor);
    else mount.appendChild(root);
    // Transition aid: if the legacy (Zepto) widget also rendered (app embed still
    // on), remove its containers so properties aren't submitted twice.
    document.querySelectorAll('.product-personalizer:not(.mc-personalizer)').forEach(function (z) {
      try { z.remove(); } catch (e) {}
    });

    var textFieldIndex = 0;
    fields.forEach(function (f, fi) {
      if (f.kind === 'ghost') return; // canvas-only
      // Class names must match Zepto's exactly: the theme's tab logic (adev.js
      // Tekst/Koordinater/Håndskrift buttons) targets '.pplr-wrapper.pplr-text'
      // and '.pplr-wrapper.pplr-.cp-sel-Photos' to show/hide/require fields.
      var zeptoCls = f.kind === 'text' ? ' pplr-text' : f.kind === 'upload' ? ' pplr- cp-sel-Photos' : '';
      var wrap = el('div', 'pplr-wrapper' + zeptoCls + ' mc-field mc-field-' + f.kind, root);
      f._wrap = wrap;

      if (f.kind === 'text') {
        var v0 = f.variants[0];
        if (v0.label) el('label', 'pplrlabel', wrap).textContent = v0.label;
        // Zepto renders a textarea ONLY for inputtype col13=2 — col13=1 fields
        // are single-line even when col7 (maxLines) > 1 (all bracelets/arcs)
        var multi = v0.maxLines > 1 && v0.inputType === '2';
        f._multi = multi;
        var input = el(multi ? 'textarea' : 'input', 'pplr_text pplr_monogram p_u_t mc-text-input', wrap);
        if (!multi) input.type = 'text';
        // single-line: native maxlength like Zepto; textarea: budget is
        // col17 × maxLines GRAPHEMES, enforced by clampMultiline in onInput
        if (!multi) input.maxLength = v0.maxChars;
        input.placeholder = v0.placeholder || '';
        input.name = "properties[" + mcPropKey(f.prop) + "]";
        input.setAttribute('data-mc-prop', f.prop);
        // field is visibly big enough for every allowed engraving line (Jonas)
        if (multi) input.rows = v0.maxLines;
        mcTrackSel(input); // 3.81: remember the caret for the symbol picker

        // emoji toggle sits to the RIGHT of the field via absolute positioning.
        // CRITICAL: the input must stay a DIRECT child of .pplr-wrapper — the
        // theme's map picker (adev.js change_input) writes coordinates into
        // wrapper.children('input/textarea').first(), exactly like with Zepto.
        // (That same mechanism writes the coords into the hidden font input —
        // reproducing the 🖊️-holds-coordinates order quirk byte-for-byte.)
        wrap.classList.add('mc-has-inline-smiley');
        var sub = el('div', 'key_layout_sub mc-smiley-inline', wrap);
        sub.innerHTML = SMILEY_SVG;
        // base + hover colour come from CSS (SVG uses currentColor) so the
        // hover tint can override — no inline color here
        var kb = el('div', 'key_layout mc-emoji-kb', wrap);
        kb.style.display = 'none';
        EMOJIS.forEach(function (e) {
          var sp = el('span', null, kb);
          sp.textContent = e;
          sp.addEventListener('click', function () {
            if (f._rich) {
              var endOff = f._rich.textContent.length;
              var off = (f._richCaret != null && f._richCaret <= endOff) ? f._richCaret : endOff;
              f._rich.focus();
              if (f._setRichCaret) f._setRichCaret(off);
              var okIns = false;
              try { okIns = document.execCommand('insertText', false, e); } catch (err) {}
              if (!okIns) {
                // 3.81: fallback inserts AT the caret too (it used to append)
                var tc = f._rich.textContent;
                f._rich.textContent = tc.slice(0, off) + e + tc.slice(off);
                f._richCaret = off + e.length;
                if (f._setRichCaret) f._setRichCaret(off + e.length);
                f._rich.dispatchEvent(new Event('input'));
              }
              return; // syncFromRich runs via the div's input event
            }
            insertAtCursor(input, e);
            onInput(f, input);
          });
        });
        var enter = el('span', 'p_space', kb);
        enter.textContent = '↲';
        enter.addEventListener('click', function () {
          if (multi) { insertAtCursor(input, '\n'); onInput(f, input); }
        });
        // rev5: visible rich field mirrors the jewelry's spacing rules. The
        // real input stays in the DOM (hidden) as the property carrier and the
        // map picker's target; everything that writes input.value still works -
        // onInput repaints the rich field from the value.
        var rich = null;
        if (TUNE.richField && !multi) {
          input.classList.add('mc-rich-src');
          input.setAttribute('tabindex', '-1');
          input.setAttribute('aria-hidden', 'true');
          input.style.cssText = 'position:absolute;opacity:0;pointer-events:none;height:1px;width:1px;overflow:hidden;';
          rich = el('div', 'pplr_text pplr_monogram p_u_t mc-rich-field', wrap);
          rich.contentEditable = 'true';
          rich.spellcheck = false;
          rich.setAttribute('inputmode', 'text');
          rich.setAttribute('data-placeholder', v0.placeholder || '');
          wrap.insertBefore(rich, input.nextSibling);
          f._rich = rich;
          var SYMF = /[\u2661\u2665\u2764+&\u00D7\u221E☀-➿\u{1F000}-\u{1FAFF}]/u;
          var ALNF = /[0-9A-Za-z\u00C0-\u024F]/;
          var CAPF = /[A-Z\u00C6\u00D8\u00C5\u00C4\u00D6\u00DC]/;
          function elegantOn() {
            var iEl = state.fontChoice[f.prop] || 0;
            var o = f.fontOptions && f.fontOptions[iEl];
            return !!(o && o.name === 'Elegant');
          }
          // 3.81 (Jonas 2026-10-18): caret = START of the selection (anchor is
          // the END when a customer marks text right-to-left), so a symbol
          // picked while text is marked lands in front of it
          function caretOffset() {
            var sel = window.getSelection();
            if (!sel.rangeCount) return null;
            var rg0 = sel.getRangeAt(0);
            if (!rich.contains(rg0.startContainer)) return null;
            var r = rg0.cloneRange();
            r.selectNodeContents(rich); r.setEnd(rg0.startContainer, rg0.startOffset);
            return r.toString().length;
          }
          function setCaret(off) {
            if (off == null) return;
            var walker = document.createTreeWalker(rich, NodeFilter.SHOW_TEXT), n, run = 0;
            while ((n = walker.nextNode())) {
              if (run + n.length >= off) {
                var sel = window.getSelection(), rg = document.createRange();
                rg.setStart(n, off - run); rg.collapse(true);
                sel.removeAllRanges(); sel.addRange(rg); return;
              }
              run += n.length;
            }
            rich.focus();
            var sel2 = window.getSelection(); sel2.selectAllChildren(rich); sel2.collapseToEnd();
          }
          f._setRichCaret = setCaret;
          ['keyup', 'mouseup', 'input', 'focus'].forEach(function (ev) {
            rich.addEventListener(ev, function () {
              var o = caretOffset();
              if (o != null) f._richCaret = o;
            });
          });
          // 3.81: phones move the caret without any key/mouse event (tap,
          // long-press loupe, drag handles) - and mouseup can land BEFORE the
          // caret moves - so the remembered position went stale and symbols
          // were put after the text. selectionchange catches every move.
          document.addEventListener('selectionchange', function () {
            if (document.activeElement !== rich) return;
            var o = caretOffset();
            if (o != null) f._richCaret = o;
          });
          var mCv = document.createElement('canvas');
          var mCtx = mCv.getContext('2d');
          // KEEP IN SYNC with drawText's segLayout pass 1+2: the field mirrors
          // the jewelry's ink-gap math exactly (bearings, cap-pairs, space
          // targets), expressed as per-span margin-left in px at field size.
          f._renderRich = function () {
            var keep = (f._keepOverride != null) ? f._keepOverride : caretOffset();
            var gs = graphemes(input.value);
            var eleg = elegantOn();
            var cs = window.getComputedStyle(rich);
            var fpx = parseFloat(cs.fontSize) || 24;
            mCtx.font = fpx + 'px ' + (cs.fontFamily || 'Helvetica');
            var it = gs.map(function (g) {
              var m = mCtx.measureText(g);
              return { g: g, w: m.width,
                       iL: (m.actualBoundingBoxLeft != null) ? -m.actualBoundingBoxLeft : 0,
                       iR: (m.actualBoundingBoxRight != null) ? m.actualBoundingBoxRight : m.width,
                       sym: SYMF.test(g), alnum: ALNF.test(g), cap: CAPF.test(g),
                       space: !g.trim(), dx: 0, padL: 0 };
            });
            var spW = mCtx.measureText(' ').width;
            // 3.81: Elegant's wide space shrinks next to a symbol - the DOM
            // span keeps its natural width, so the cut goes onto the NEXT
            // span's margin-left (same geometry as segLayout's padR)
            var symSp = (eleg && TUNE.elegantSymbolSpace < 1) ? TUNE.elegantSymbolSpace : 1;
            if (symSp < 1) mcSymSpaces(it).forEach(function (si) {
              if (si + 1 < it.length) it[si + 1].padL -= (1 - symSp) * it[si].w;
            });
            spW *= symSp; // pass 2 targets below are symbol gaps only
            // pass 1: min ink gaps for 0-space adjacency (+ Elegant cap pairs)
            var cur = 0, prevEnd = null, prevIdx = -1;
            for (var i2 = 0; i2 < it.length; i2++) {
              var o = it[i2]; cur += o.padL;
              if (prevEnd != null && !o.space) {
                var pv = it[prevIdx], need = 0;
                if ((o.sym && pv.alnum) || (pv.sym && o.alnum)) need = fpx * (CAPF.test(o.sym ? pv.g : o.g) ? 0.20 : 0.12);
                else if (eleg && o.cap && pv.cap) need = fpx * 0.08;
                if (need) { var gap = (cur + o.iL) - prevEnd; if (gap < need) { o.padL += need - gap; cur += need - gap; } }
              }
              if (!o.space) { prevEnd = cur + o.iR; prevIdx = i2; }
              cur += o.w;
            }
            // pass 2: space-aware ink targets (same as the jewelry)
            var pos = [], run = 0;
            it.forEach(function (o) { run += o.padL; pos.push(run); run += o.w; });
            for (var i3 = 0; i3 < it.length; i3++) {
              var oS = it[i3];
              if (!oS.sym) continue;
              var li = i3 - 1, nL = 0; while (li >= 0 && it[li].space) { li--; nL++; }
              var ri = i3 + 1, nR = 0; while (ri < it.length && it[ri].space) { ri++; nR++; }
              var hasL = li >= 0 && it[li].alnum, hasR = ri < it.length && it[ri].alnum;
              if (!hasL && !hasR) continue;
              var useOpt = TUNE.opticalSpacing;
              var fCss = mCtx.font;
              var gapTo = function (ai, bi2) {
                var dist = (pos[bi2] + it[bi2].dx) - (pos[ai] + it[ai].dx);
                if (!useOpt) return null;
                return mcOpticalGap(fCss, it[ai].g, 0, fCss, it[bi2].g, 0, dist);
              };
              var tgt = function (n, capNb) {
                if (useOpt) return n > 0 ? n * spW + fpx * 0.06 : fpx * 0.30;
                return n > 0 ? n * spW : fpx * (capNb ? 0.20 : 0.12);
              };
              var gL = null, gR = null, tL = 0, tR = 0, oL = null, oR = null;
              if (hasL) { oL = gapTo(li, i3);
                gL = (oL && oL.mean != null) ? oL.mean : (pos[i3] + oS.dx + oS.iL) - (pos[li] + it[li].dx + it[li].iR);
                tL = tgt(nL, it[li].cap); }
              if (hasR) { oR = gapTo(i3, ri);
                gR = (oR && oR.mean != null) ? oR.mean : (pos[ri] + it[ri].dx + it[ri].iL) - (pos[i3] + oS.dx + oS.iR);
                tR = tgt(nR, it[ri].cap); }
              var shift = 0;
              if (hasL && hasR) shift = ((tL - gL) - (tR - gR)) / 2;
              else if (hasL) shift = tL - gL;
              else shift = gR - tR;
              var FLOOR = fpx * 0.09;
              if (useOpt) {
                if (hasL && oL && oL.min != null) shift = Math.max(shift, FLOOR - oL.min);
                if (hasR && oR && oR.min != null) shift = Math.min(shift, oR.min - FLOOR);
              }
              oS.dx += shift;
            }
            var html = '';
            for (var gi = 0; gi < it.length; gi++) {
              var mar = it[gi].padL + it[gi].dx - (gi > 0 ? it[gi - 1].dx : 0);
              html += '<span' + (Math.abs(mar) > 0.4 ? ' style="margin-left:' + mar.toFixed(1) + 'px"' : '') + '>' +
                it[gi].g.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
            }
            rich.innerHTML = html;
            if (document.activeElement === rich) setCaret(keep);
            if (keep != null) f._richCaret = keep;
          };
          function syncFromRich() {
            var raw = rich.textContent.replace(/\n/g, '');
            var off = (document.activeElement === rich) ? caretOffset() : null;
            var txt = mcNormalizeText(raw);
            // 3.82: caret measured on the NORMALISED text - stripping VS16
            // (iOS heart) used to land the caret one place too far right
            var keepN = (off != null) ? mcNormalizeText(raw.slice(0, off)).length : null;
            var arr = graphemes(txt);
            if (arr.length > v0.maxChars) {
              var prev = input.value || '';
              if (keepN != null && keepN < txt.length && graphemes(prev).length <= v0.maxChars) {
                // 3.82: typing/pasting into the MIDDLE of a full field used to
                // push the last characters out silently - refuse the edit instead
                var added = Math.max(0, txt.length - prev.length);
                txt = prev;
                keepN = Math.max(0, Math.min(prev.length, keepN - added));
              } else {
                txt = arr.slice(0, v0.maxChars).join('');
                if (keepN != null) keepN = Math.min(keepN, txt.length);
              }
            }
            input.value = txt;
            f._keepOverride = keepN;
            onInput(f, input, counter);
            // 3.82: never rebuild the field's DOM while an Android/iOS keyboard
            // is composing a word (doubled/garbled letters); repaint on end
            if (!f._composing) f._renderRich();
            f._keepOverride = null;
          }
          rich.addEventListener('compositionstart', function () { f._composing = true; });
          rich.addEventListener('compositionend', function () { f._composing = false; syncFromRich(); });
          rich.addEventListener('input', syncFromRich);
          rich.addEventListener('blur', function () { f._composing = false; syncFromRich(); });
          rich.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') ev.preventDefault(); });
          rich.addEventListener('paste', function (ev) {
            ev.preventDefault();
            var txt = (ev.clipboardData || window.clipboardData).getData('text/plain') || '';
            document.execCommand('insertText', false, txt.replace(/\n/g, ' '));
          });
        }

        sub.addEventListener('click', function () {
          // theme CSS carries .key_layout{display:none!important} — override in kind
          var open = kb.getAttribute('data-mc-open') === '1';
          if (open) { kb.style.setProperty('display', 'none', 'important'); kb.setAttribute('data-mc-open', '0'); }
          else { kb.style.setProperty('display', 'flex', 'important'); kb.setAttribute('data-mc-open', '1'); }
        });

        // char counter — Zepto textarea budget is col17 × maxLines graphemes
        var budget = multi ? v0.maxChars * v0.maxLines : v0.maxChars;
        var counter = el('span', 'pplr-character-count', wrap);
        counter.innerHTML = '<span class="ct">' + budget + '</span> <span class="lt">' +
          t('charsLeft', 'Tegn tilbage') + '</span> <span class="lm">/ ' + budget + '</span>';

        // centre the smiley on the input by measurement — pair fields carry a
        // theme-hidden ♀/♂ pplrlabel that pushed the CSS-offset icon to the
        // field's bottom edge (SE desktop, Jonas 2026-07-07)
        f._placeSmiley = function () {
          var fld = f._rich || input;
          if (!fld.offsetHeight || !sub.offsetHeight) return;
          sub.style.top = (fld.offsetTop + (fld.offsetHeight - sub.offsetHeight) / 2) + 'px';
        };

        // font selector: from multi-meta FONT variants OR fontgroup_json.
        // Position-variant fields (e.g. Bangle inside/outside layouts, same font
        // file per meta) must use the font group — not the duplicate metas.
        var fontOptions = null;
        // Zepto resolves the font group per layer via col34 (fontgroup_json key;
        // '1' = none). Skrifttype carries Moderne scale 1.1 / Elegant 1.18 —
        // reading FONTS (Moderne 1.0) rendered Moderne 10% small on 30 products.
        var fieldGroup = (v0.fontGroupName && v0.fontGroupName !== '1'
          && CFG.fontGroups && CFG.fontGroups[v0.fontGroupName]) || FONT_GROUP;
        if (f.variants.length > 1 && f.variantsKind !== 'position') {
          // multi-meta font variants: each row carries its own size (col34='1').
          // Naming: filename hint where available, else POSITIONAL (meta 0 =
          // Moderne face, meta 1 = Elegant). Filename-only naming broke on
          // A67.ttf (an Elegant face not named 'Elegant*'): both variants got
          // 'Moderne' and the DEFAULT flipped to the script font
          // (cirkel-m-zirkoner-solv, audit sweep 2026-07-06).
          var elegantAt = -1;
          f.variants.forEach(function (v, i) {
            if (elegantAt === -1 && v.font.indexOf('Elegant') === 0) elegantAt = i;
          });
          fontOptions = f.variants.map(function (v, i) {
            var isElegant = elegantAt >= 0 ? i === elegantAt : i > 0;
            return { name: isElegant ? 'Elegant' : 'Moderne',
                     file: v.font, scale: 1, variantIdx: i };
          });
        } else if (fieldGroup) {
          var names0 = Object.keys(fieldGroup).filter(function (n) { return fieldGroup[n][3]; });
          if (names0.length > 1) {
            fontOptions = names0.map(function (n) {
              return { name: n, file: mcFont(fieldGroup[n][0]),
                       scale: parseFloat(fieldGroup[n][1]) || 1, variantIdx: 0 };
            });
          } else if (names0.length === 1) {
            // single enabled font: no selector, but the group scale still applies
            f._groupScale = parseFloat(fieldGroup[names0[0]][1]) || 1;
            f._groupFontName = names0[0];
          }
        }
        if (fontOptions) {
          textFieldIndex += 1;
          // per-field col24 key verbatim; positional '🖊️'/' 🖊️' only as fallback
          var propName = f.variants[0].fontProp || fontPropName(textFieldIndex);
          // own wrapper, Zepto DOM parity: theme hides .pplr-font-select in map
          // mode, and the map picker writes coords into its first input (the
          // hidden font property) exactly like the legacy app
          var fwrap = el('div', 'pplr-wrapper pplr-font-select mc-field mc-field-font', root);
          f._fontWrap = fwrap;
          var hidden = el('input', null, fwrap);
          hidden.type = 'hidden';
          hidden.name = 'properties[' + mcPropKey(propName) + ']';
          f._fontInput = hidden; // renamed positionally by syncFontPropNames()
          var defIdx = 0;
          fontOptions.forEach(function (o, i) { if (o.name === 'Moderne') defIdx = i; });
          hidden.value = fontOptions[defIdx].name;
          state.fontChoice[f.prop] = defIdx;
          f.fontOptions = fontOptions;
          // the text field itself types in the selected font (Zepto parity:
          // their textarea carried font-family:<selectedfamily>)
          var applyInputFont = function (o) {
            var fam2 = fontFamilies[o.file];
            var stack2 = (fam2 ? '"' + fam2 + '", ' : '') + 'Helvetica, Arial, sans-serif';
            input.style.fontFamily = stack2;
            if (f._rich) { f._rich.style.fontFamily = stack2; if (f._renderRich) f._renderRich(); }
          };
          applyInputFont(fontOptions[defIdx]);
          f._applyInputFont = applyInputFont;

          // Zepto look: always-visible inline thumbs (.pplrfontthumb), selected
          // item carries .selected-font — theme CSS styles both already.
          var sel = el('div', 'pplrfontthumb mc-font-select', fwrap);
          var items = [];
          f._fontItems = items;
          fontOptions.forEach(function (o, i) {
            var it = el('span', 'pplr-selecter-item' + (i === defIdx ? ' selected-font' : ''), sel);
            it.setAttribute('data-value', o.name); // adev.css styles per font name
            it.textContent = o.name;
            it.style.fontFamily = (fontFamilies[o.file] ? '\"' + fontFamilies[o.file] + '\", ' : '') + 'Helvetica, Arial, sans-serif';
            it.addEventListener('click', function () {
              state.fontChoice[f.prop] = i;
              hidden.value = o.name;
              applyInputFont(o);
              items.forEach(function (c) { c.classList.remove('selected-font'); });
              it.classList.add('selected-font');
              render();
            });
            items.push(it);
          });
        }

        input.addEventListener('input', function () { onInput(f, input, counter); });
        input.addEventListener('keyup', function () { onInput(f, input, counter); });
        input.addEventListener('change', function () { onInput(f, input, counter); });
        // The theme's Koordinater map picker (adev.js) writes the coordinate
        // string into this field programmatically — no events fire. Poll for
        // silent value changes so the preview always follows.
        setInterval(function () {
          if (input.value !== (state.values[f.prop] || '')) onInput(f, input, counter);
        }, 700);
      }

      if (f.kind === 'upload') {
        var v = f.variants[0];
        el('label', 'oindexlabel pplrlabel', wrap).textContent =
          v.label || t('uploadLabel', 'Upload et klart billede af din Tegning / Håndskrift');
        var fileIn = el('input', 'pplr_monogram fileupload mc-upload', wrap);
        fileIn.type = 'file';
        fileIn.accept = 'image/*';
        fileIn.name = 'properties[' + mcImageKey(f.prop) + ']';
        v._fileInput = fileIn; // so the cropper's delete button can reset it
        var cropIn = el('input', 'pplr-crop pplr_aux mc-crop-file', wrap);
        cropIn.type = 'file';
        cropIn.name = 'properties[_' + f.prop + '_crop]';
        cropIn.style.display = 'none';
        cropIn.tabIndex = -1;
        fileIn.addEventListener('change', function () {
          state.uploadFile = fileIn.files[0] || null;
          f._uploadFile = state.uploadFile;
          // attaching a drawing is an engraving — drop the opt-in (see onInput)
          if (state.uploadFile) resetNoEngraving();
          if (state.uploadFile) {
            // Zepto validates minimum dimensions (config cols 32/33, typically
            // 200x200) so the engraving source is usable
            var probe = new Image();
            probe.onload = function () {
              var minW = v.minW || 200, minH = v.minH || 200;
              if (probe.naturalWidth < minW || probe.naturalHeight < minH) {
                alert(MC_MSG.small.replace('{w}', minW).replace('{h}', minH));
                fileIn.value = '';
                state.uploadFile = null;
                f._uploadFile = null;
                f._cropImage = null;
                state.cropImage = null;
                render(); validate();
                return;
              }
              // phone-camera originals run 3-12MB and post inside the blocking
              // multipart /cart/add — downscale to <=2000px JPEG here (while
              // the customer is still cropping, so the cost is invisible).
              // 2000px comfortably feeds the <=1400px crop export. EXIF
              // orientation gets baked in by drawImage, so the re-encoded file
              // needs no EXIF handling downstream.
              var needsShrink = state.uploadFile.size > 600 * 1024 ||
                Math.max(probe.naturalWidth, probe.naturalHeight) > 2000;
              if (!needsShrink) {
                openCropper(f, state.uploadFile, v, cropIn);
                render(); validate();
                return;
              }
              var sc = Math.min(1, 2000 / Math.max(probe.naturalWidth, probe.naturalHeight));
              var dc = document.createElement('canvas');
              dc.width = Math.round(probe.naturalWidth * sc);
              dc.height = Math.round(probe.naturalHeight * sc);
              dc.getContext('2d').drawImage(probe, 0, 0, dc.width, dc.height);
              dc.toBlob(function (blob) {
                if (blob && blob.size < state.uploadFile.size) {
                  var base = (state.uploadFile.name || 'billede').replace(/\.[^.]+$/, '');
                  setFileInput(fileIn, blob, base + '.jpg', 'image/jpeg');
                  state.uploadFile = fileIn.files[0] || state.uploadFile;
                  f._uploadFile = state.uploadFile;
                }
                openCropper(f, state.uploadFile, v, cropIn);
                render(); validate();
              }, 'image/jpeg', 0.85);
            };
            // 3.82: an image the browser can't decode (HEIC on desktop, a
            // broken file) used to fail silently and still count as uploaded
            probe.onerror = function () {
              alert(MC_MSG.unreadable);
              try { fileIn.value = ''; } catch (e) {}
              state.uploadFile = null;
              f._uploadFile = null;
              f._cropImage = null;
              state.cropImage = null;
              render(); validate();
            };
            probe.src = URL.createObjectURL(state.uploadFile);
          } else {
            render();
            validate();
          }
        });
      }

      if (f.kind === 'select') {
        var sv = f.variants[0];
        // font-selector-as-dropdown (prop 🖊️, group Skrift) → handled by font chips
        if (f.prop === '🖊️' || sv.raw[51] === 'Skrift') { wrap.remove(); return; }
        var group = CFG.dropdowns && CFG.dropdowns[sv.raw[51]];
        if (!group) { wrap.remove(); return; }
        if (sv.label || sv.prop) el('label', 'pplrlabel', wrap).textContent = sv.label || sv.prop;
        var hiddenSel = el('input', 'pplr_select', wrap);
        hiddenSel.type = 'hidden';
        hiddenSel.name = 'properties[' + f.prop + ']';
        wrap.setAttribute('data-mc-select', f.prop);
        var opts = Object.keys(group);
        var def = (sv.raw[58] || '').replace(/^_/, '');
        if (opts.indexOf(def) === -1) def = opts[0];
        state.selects = state.selects || {};
        state.selects[f.prop] = def;
        hiddenSel.value = def;
        var box = el('div', 'mc-select-chips', wrap);
        // MC 3.48 (Claude 2026-10-05): the bangle PLACEMENT selector
        // (Indvendig / Udvendig / Begge — the same Danish keys applyConditions
        // keys on) renders as pills ABOVE the engraving field (Jonas), and
        // picking a side pins the live preview to that side of the bangle even
        // before anything is typed (see draw()). Other selects are untouched.
        var isPlacement = opts.some(function (o) { return /indvendig|udvendig/i.test(o); });
        if (isPlacement) {
          wrap.classList.add('mc-field-placement');
          var firstField = root.querySelector('.mc-field');
          if (firstField && firstField !== wrap) root.insertBefore(wrap, firstField);
          // warm the cache for every side's photo on first intent (hover /
          // touch / keyboard focus) so the switch on click has no wait
          ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
            box.addEventListener(evt, preloadBaseImages, { passive: true, once: true });
          });
        }
        opts.forEach(function (o) {
          var chip = el('span', 'pplr-selecter-item mc-select-chip' + (o === def ? ' mc-selected' : ''), box);
          chip.textContent = o;
          if (isPlacement) {
            chip.setAttribute('role', 'button');
            chip.setAttribute('tabindex', '0');
            chip.setAttribute('aria-pressed', o === def ? 'true' : 'false');
            chip.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); chip.click(); }
            });
          }
          chip.addEventListener('click', function () {
            state.selects[f.prop] = o;
            hiddenSel.value = o;
            box.querySelectorAll('.mc-select-chip').forEach(function (c) {
              c.classList.remove('mc-selected');
              if (isPlacement) c.setAttribute('aria-pressed', 'false');
            });
            chip.classList.add('mc-selected');
            if (isPlacement) {
              chip.setAttribute('aria-pressed', 'true');
              state.placementPicked = true;
            }
            applyConditions();
            render();
            validate();
          });
        });
        f.selectOptions = opts;
      }
    });

    // smiley vertical centring: measure once now (root is already mounted),
    // again next frame (theme CSS may land late) and on resize
    function placeSmileys() {
      fields.forEach(function (f) { if (f._placeSmiley) f._placeSmiley(); });
    }
    placeSmileys();
    requestAnimationFrame(placeSmileys);
    window.addEventListener('resize', placeSmileys);

    // mobile-only "view your jewelry" button — on desktop the live preview
    // overlays the main image beside the options; on mobile the customer types
    // below the fold, so this opens the current preview in a modal (like live).
    previewBtn = el('button', 'mc-preview-btn', root);
    previewBtn.type = 'button';
    previewBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>' +
      '<span>' + (CFG.previewBtnLabel || 'Se dit smykke') + '</span>';
    previewBtn.addEventListener('click', function (e) { e.preventDefault(); openPreviewModal(); });

    applyConditions();
    initThemeTabs();
    buildPreview();
    hookSubmit();
    validate();
  }

  // show the current jewelry preview large in a modal (mobile "view your …")
  function openPreviewModal() {
    if (!previewCanvas) return;
    var url;
    try { url = previewCanvas.toDataURL('image/png'); } catch (e) { return; }
    var ov = el('div', 'mc-preview-modal', document.body);
    var mbox = el('div', 'mc-preview-modal-box', ov);
    var x = el('button', 'mc-crop-close', mbox);
    x.type = 'button'; x.setAttribute('aria-label', 'Luk');
    x.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
    var img = el('img', null, mbox); img.src = url;
    function shut(e) { if (e) e.preventDefault(); if (ov.parentNode) ov.parentNode.removeChild(ov); }
    x.addEventListener('click', shut);
    ov.addEventListener('click', function (e) { if (e.target === ov) shut(); });
  }

  // The theme's option tabs (Tekst / Koordinater / Håndskrift) show and hide our
  // wrappers via adev.js on CLICK — but the initial page state is ours to set:
  // hide the photo-upload block unless the handwriting tab is already active.
  function initThemeTabs() {
    var tabs = document.querySelectorAll('.adev-custom-buttons span');
    if (!tabs.length) return;
    var active = document.querySelector('.adev-custom-buttons span.active');
    var isHandwriting = active && /h[aå]nd|handwrit/i.test((active.getAttribute('data-adev-option') || '') + ' ' + active.textContent);
    // visibility is CSS-driven via the .mc-hw root class (see mc-personalizer.css)
    // — the theme's adev.css otherwise keeps the Photos wrapper display:none.
    if (root) root.classList.toggle('mc-hw', !!isHandwriting);
    fields.forEach(function (f) {
      if (f.kind !== 'upload' || !f._wrap) return;
      var fi = f._wrap.querySelector('input[type="file"]');
      if (fi) fi.disabled = !isHandwriting;
    });
    // Switching engraving mode (Tekst / Koordinater / Håndskrift) RESETS the
    // personalization so a previous mode's content (e.g. an uploaded drawing)
    // never lingers on the jewelry in another mode.
    var lastOpt = active ? (active.getAttribute('data-adev-option') || '') : '';
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var opt = tab.getAttribute('data-adev-option') || '';
        if (opt !== lastOpt) { lastOpt = opt; resetPersonalization(); }
        setTimeout(function () {
          // re-apply upload-field visibility for the newly active tab (CSS-driven
          // via .mc-hw — see the initial block + mc-personalizer.css)
          var isHw = /h[aå]nd|handwrit/i.test(opt + ' ' + tab.textContent);
          if (root) root.classList.toggle('mc-hw', isHw);
          fields.forEach(function (f) {
            if (f.kind !== 'upload' || !f._wrap) return;
            var fi = f._wrap.querySelector('input[type="file"]');
            if (fi) fi.disabled = !isHw;
          });
          validate(); render();
        }, 150);
      });
    });
  }

  // Clear ALL personalization content (uploaded image + every text/coordinate
  // field) so switching engraving modes starts fresh.
  function resetPersonalization() {
    state.uploadFile = null; state.cropImage = null; state.cropBlob = null;
    fields.forEach(function (f) { f._uploadFile = null; f._cropImage = null; });
    state.values = {};
    fields.forEach(function (f) {
      if (f.kind === 'text' && f._wrap) {
        var inp = f._wrap.querySelector('.mc-text-input');
        if (inp) inp.value = '';
        // 3.82: the visible field kept showing the old text after a tab switch
        if (f._rich) f._rich.textContent = '';
        var v0 = f.variants[0];
        var budget = f._multi ? v0.maxChars * v0.maxLines : v0.maxChars;
        var ct = f._wrap.querySelector('.pplr-character-count .ct');
        if (ct) ct.textContent = budget;
      }
      if (f._fileInput) { try { f._fileInput.value = ''; } catch (e) {} }
    });
    root.querySelectorAll('.mc-crop-file, .pplr-crop').forEach(function (n) { try { n.value = ''; } catch (e) {} });
    // a fresh mode starts from a clean slate — including the no-engraving opt-in
    resetNoEngraving();
    render(); validate();
  }

  /* ---------- conditional visibility (select-driven, e.g. Bangle Gravering) ---- */
  function setFieldActive(f, active) {
    f._active = active;
    [f._wrap, f._fontWrap].forEach(function (w) {
      if (!w) return;
      w.style.display = active ? '' : 'none';
      // Hidden fields must NOT submit (Zepto orders carry no keys for inactive
      // fields — see order #25069 vs #25113). Disabled inputs are excluded from
      // both native form posts and FormData.
      w.querySelectorAll('input, textarea, select').forEach(function (n) {
        n.disabled = !active;
      });
    });
  }
  function applyConditions() {
    fields.forEach(function (sf) {
      if (sf.kind !== 'select' || !sf.selectOptions) return;
      var val = (state.selects && state.selects[sf.prop]) || '';
      var isBegge = /begge/i.test(val);
      fields.forEach(function (f) {
        if (f.kind !== 'text' || !f._wrap) return;
        var matchesOpt = sf.selectOptions.some(function (o) {
          if (/begge/i.test(o)) return false;
          // prefix-match on the option stem: tolerates the live config's
          // 'Udvending indgravering' typo (vs option 'Udvendig')
          var stem = o.slice(0, 6).toLowerCase();
          return f.prop.toLowerCase().indexOf(stem) === 0;
        });
        if (matchesOpt) {
          setFieldActive(f, isBegge);
        } else if (f.variantsKind === 'position') {
          setFieldActive(f, !isBegge);
          state.posChoice = state.posChoice || {};
          // Map the selected option to the meta whose BASE IMAGE matches it:
          // 'Indvendig' ↔ *inderside*, 'Udvendig' ↔ *yderside* (filename-based,
          // robust against meta ordering — fixes swapped inside/outside photos).
          var want = /indvendig/i.test(val) ? /inderside/i : /yderside|_B\.|-B\./i;
          var pick = 0;
          f.variants.forEach(function (v, i) { if (want.test(v.baseImage)) pick = i; });
          state.posChoice[f.prop] = pick;
        }
      });
    });
    syncFontPropNames();
  }

  // Font property keys are positional among ACTIVE fields only (Zepto convention:
  // first submitting field's font = 🖊️, second = ' 🖊️', …). Recompute whenever
  // visibility changes so Begge mode yields 🖊️ + ' 🖊️' (never a 2-space key)
  // and single mode yields just 🖊️.
  function syncFontPropNames() {
    // Zepto posts each field's col24 font key BYTE-EXACT (spaces significant:
    // veninde '🖊️ ' trailing / kæreste ' 🖊️' leading — real-order validated).
    // Positional names only when the config carries no key, or when two ACTIVE
    // fields would collide on the same key.
    var used = {};
    var n = 0;
    fields.forEach(function (f) {
      if (f.kind !== 'text' || !f._fontInput) return;
      if (f._active === false) return;
      n += 1;
      var key = f.variants[0].fontProp;
      if (!key || used[key]) key = fontPropName(n);
      while (used[key]) key = ' ' + key;
      used[key] = 1;
      f._fontInput.name = 'properties[' + mcPropKey(key) + ']';
    });
  }

  // 3.81 (Jonas 2026-10-18): a caret at the very START of the text is
  // selectionStart 0, and the old `selectionStart || length` read that 0 as
  // "no caret" - so a symbol meant to go in front of the text was appended
  // after it. The position is now taken as-is (live selection while the
  // field has focus, else the last one we saw), and marked text is never
  // overwritten: the symbol goes in front of the marked text.
  function mcTrackSel(input) {
    if (input._mcSelTracked) return;
    input._mcSelTracked = true;
    var save = function () {
      if (typeof input.selectionStart === 'number') input._mcSel = input.selectionStart;
    };
    // now AND after the browser has moved the caret (mouseup/touchend fire
    // before it); blur records the final spot before the picker is tapped
    ['keyup', 'mouseup', 'touchend', 'input', 'select', 'focus', 'blur'].forEach(function (ev) {
      input.addEventListener(ev, function () { save(); setTimeout(save, 0); });
    });
    document.addEventListener('selectionchange', function () {
      if (document.activeElement === input) save();
    });
  }
  function insertAtCursor(input, text) {
    var len = input.value.length;
    var s = (document.activeElement === input && typeof input.selectionStart === 'number')
      ? input.selectionStart
      : (typeof input._mcSel === 'number' ? input._mcSel
        : (typeof input.selectionStart === 'number' ? input.selectionStart : len));
    s = Math.max(0, Math.min(s, len));
    var newVal = input.value.slice(0, s) + text + input.value.slice(s);
    // single-line fields carry native maxlength; textareas are budgeted by
    // clampMultiline in onInput instead
    if (input.maxLength > 0 && newVal.length > input.maxLength) return;
    input.value = newVal;
    input.selectionStart = input.selectionEnd = s + text.length;
    input._mcSel = s + text.length;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---------- optical symbol spacing (rev7) ---------- */
  var _mcProf = {};
  function mcGlyphProfile(fontCss, g) {
    var key = fontCss + '|' + g;
    if (_mcProf[key]) return _mcProf[key];
    var c = document.createElement('canvas');
    var x = c.getContext('2d');
    x.font = fontCss;
    var m = x.measureText(g);
    var bL = Math.ceil(m.actualBoundingBoxLeft || 0);
    var bR = Math.ceil(m.actualBoundingBoxRight || m.width);
    var asc = Math.ceil(m.actualBoundingBoxAscent || 20);
    var desc = Math.ceil(m.actualBoundingBoxDescent || 8);
    var w = bL + bR + 8, h = asc + desc + 8;
    c.width = w; c.height = h;
    x = c.getContext('2d');
    x.font = fontCss; x.textBaseline = 'alphabetic'; x.fillStyle = '#000';
    var ox = bL + 4, oy = asc + 4;
    x.fillText(g, ox, oy);
    var d = x.getImageData(0, 0, w, h).data;
    var L = [], R = [];
    for (var y = 0; y < h; y++) {
      var l = null, r = null;
      for (var xx = 0; xx < w; xx++) {
        if (d[(y * w + xx) * 4 + 3] > 40) { if (l === null) l = xx; r = xx; }
      }
      L.push(l === null ? null : l - ox);
      R.push(r === null ? null : r - ox);
    }
    var pr = { L: L, R: R, oy: oy };
    _mcProf[key] = pr;
    return pr;
  }
  // mean/min horizontal air between A's right profile and B's left profile,
  // with B's origin `dist` px right of A's and shifted `dyB-dyA` px vertically
  function mcOpticalGap(fontA, gA, dyA, fontB, gB, dyB, dist) {
    var a = mcGlyphProfile(fontA, gA), b = mcGlyphProfile(fontB, gB);
    var sum = 0, n = 0, min = null;
    for (var ya = 0; ya < a.R.length; ya++) {
      if (a.R[ya] === null) continue;
      var yb = Math.round((ya - a.oy) + (dyA || 0) - (dyB || 0)) + b.oy;
      if (yb < 0 || yb >= b.L.length || b.L[yb] === null) continue;
      var gp = (dist + b.L[yb]) - a.R[ya];
      sum += gp; n++;
      if (min === null || gp < min) min = gp;
    }
    if (!n) return null;
    return { mean: sum / n, min: min, rows: n };
  }
  window.__mcOpticalGap = mcOpticalGap;

  // 3.81: indices of space items that sit in a run of spaces touching a
  // symbol on either side ('A + B', 'Anna  ♡ Jonas'); word spaces between
  // two letters are not returned
  function mcSymSpaces(it) {
    var out = [];
    for (var i = 0; i < it.length; i++) {
      if (!it[i].space) continue;
      var l = i - 1; while (l >= 0 && it[l].space) l--;
      var r = i + 1; while (r < it.length && it[r].space) r++;
      if ((l >= 0 && it[l].sym) || (r < it.length && it[r].sym)) out.push(i);
    }
    return out;
  }
  function mcNormalizeText(t) {
    return String(t || '').replace(/[\uFE0E\uFE0F]/g, '')
      .replace(/\u2665/g, '\u2764').replace(/\u267E/g, '\u221E');
  }
  function onInput(f, input, counter) {
    if (TUNE.inputNormalize && input.value) {
      var normed = mcNormalizeText(input.value);
      if (normed !== input.value) {
        var p0 = input.selectionStart || 0, delta = input.value.length - normed.length;
        input.value = normed;
        try { input.setSelectionRange(Math.max(0, p0 - delta), Math.max(0, p0 - delta)); } catch (e) {}
      }
    }
    var v0 = f.variants[0];
    if (f._rich && f._renderRich && f._rich.textContent !== input.value &&
        document.activeElement !== f._rich) f._renderRich();
    if (f._multi) {
      // Zepto limitTextarea: per-line grapheme limit (col17), greedy word-wrap,
      // silent truncation past maxLines
      var clamped = clampMultiline(input.value, v0.maxChars, v0.maxLines);
      // 3.82: an edit in line 1 that wraps a word down used to delete the last
      // line without warning, and typing on past a full last line mangled it
      // ('for altid' -> 'forekst'). If an edit would LOSE text, it is refused
      // and the text stays as it was (a first paste into an empty field is
      // still trimmed to fit).
      var inkOf = function (sv) { return graphemes(String(sv).replace(/\s+/g, '')).length; };
      var prevOk = state.values[f.prop];
      if (clamped !== input.value && inkOf(clamped) < inkOf(input.value) &&
          typeof prevOk === 'string' && prevOk !== '' &&
          clampMultiline(prevOk, v0.maxChars, v0.maxLines) === prevOk) {
        var back = Math.max(0, (input.selectionStart || 0) - (input.value.length - prevOk.length));
        input.value = prevOk;
        try { input.setSelectionRange(back, back); } catch (e) {}
        clamped = prevOk;
      }
      if (clamped !== input.value) {
        var atEnd = input.selectionStart >= input.value.length;
        var pos = input.selectionStart;
        input.value = clamped;
        input.selectionStart = input.selectionEnd = atEnd ? clamped.length : Math.min(pos, clamped.length);
      }
    } else {
      // single-line: strip pasted newlines (Zepto <input> can't hold them)
      if (input.value.indexOf('\n') !== -1) input.value = input.value.replace(/\n+/g, ' ');
    }
    state.values[f.prop] = input.value;
    // the customer changed their mind and IS engraving after all — untick the
    // opt-in (the two must never both reach the order) and take the question
    // away: "you haven't added an engraving" is no longer true.
    if (input.value.trim()) resetNoEngraving();
    if (counter) {
      // Zepto counter: budget − graphemes(text minus newlines); emoji = 1
      var budget = f._multi ? v0.maxChars * v0.maxLines : v0.maxChars;
      var used = graphemes(input.value.replace(/\n/g, '')).length;
      counter.querySelector('.ct').textContent = Math.max(0, budget - used);
    }
    render();
    validate();
  }

  /* ---------- preview canvas in product gallery ---------- */
  // Find the VISIBLE main product-image box. The gallery is a swiper whose slides
  // are cloned from <template> by the theme JS after load, so we may need to wait
  // and must pick the active/visible slide (not a hidden one or the template).
  function findImgBox() {
    // desktop media markup first; the LAST selector is the MOBILE gallery — the
    // theme shows a thumbnail swiper as the main image on phones (no
    // .product-single__media__image exists there at all). minW 200 keeps it
    // from ever matching the small desktop thumbnail strip.
    var sels = [
      ['.swiper-slide-active .product-single__media__image', 40],
      ['.product-single__media--selected .product-single__media__image', 40],
      ['[data-mc-preview-mount]', 40],
      ['.product-single__media__image', 40],
      ['.swiper-slide-active .product-single__thumbnail__wrapper', 200]
    ];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i][0]);
      var minW = sels[i][1];
      for (var j = 0; j < els.length; j++) {
        var e = els[j];
        if (e.offsetParent === null) continue; // hidden (inactive slide / desktop-only gallery)
        var r = e.getBoundingClientRect();
        if (r.width > minW && r.height > minW) return e;
      }
    }
    return null;
  }

  function mountPreview(imgBox, wrapper) {
    if (wrapper.parentElement === imgBox) return;
    imgBox.classList.add('pplr');
    wrapper.classList.add('mc-preview-overlay');
    if (getComputedStyle(imgBox).position === 'static') imgBox.style.position = 'relative';
    imgBox.appendChild(wrapper);
    // size the overlay to the photo's RENDERED rect (the theme letterboxes the
    // img inside the box) — a full-box overlay would look zoomed-in
    var fitOverlay = function () {
      var im = imgBox.querySelector('img');
      if (!im) return;
      var b = imgBox.getBoundingClientRect(), r = im.getBoundingClientRect();
      if (r.width < 10) return;
      wrapper.style.top = (r.top - b.top) + 'px';
      wrapper.style.left = (r.left - b.left) + 'px';
      wrapper.style.width = r.width + 'px';
      wrapper.style.height = r.height + 'px';
      wrapper.style.right = 'auto';
      wrapper.style.bottom = 'auto';
    };
    fitOverlay();
    window.addEventListener('resize', fitOverlay);
    wrapper._mcFit = fitOverlay;
  }

  function buildPreview() {
    var wrapper = el('div', 'pplr_preview_wrapper mc-preview-wrapper mc-preview-overlay');
    previewCanvas = el('canvas', null, wrapper);
    previewCanvas.width = previewCanvas.height = CANVAS * previewScale(); // hi-DPI → sharp
    previewCtx = previewCanvas.getContext('2d');
    wrapper.style.display = 'none';
    // Overlay ON TOP of the main product photo — the main image becomes the live
    // engraving preview the moment the customer types. NEVER insert a second
    // inline image (that caused a duplicate photo under the options on mobile
    // when the gallery JS hadn't cloned the slide yet); poll for the real image.
    var tries = 0;
    (function attempt() {
      var box = findImgBox();
      if (box) { mountPreview(box, wrapper); render(); return; }
      if (tries++ < 40) { setTimeout(attempt, 150); return; } // wait up to ~6s for the gallery JS
      render(); // give up mounting; keep the canvas ready but show no duplicate image
    })();
    // On rotate / breakpoint change the visible gallery image can change — re-run
    // the mount+fit so the overlay follows onto the mobile main image.
    window.addEventListener('resize', function () { render(); });
    window.addEventListener('orientationchange', function () { setTimeout(render, 250); });
  }

  function personalizationHasContent() {
    var has = false;
    fields.forEach(function (f) {
      if (f._active === false) return;
      if (f.kind === 'text' && (state.values[f.prop] || '').trim()) has = true;
      if (f.kind === 'upload' && (f._uploadFile || state.uploadFile)) has = true;
    });
    return has;
  }

  function activeVariant(f) {
    var i = state.fontChoice[f.prop] || 0;
    var base;
    if (f.variantsKind === 'position') {
      var pi = (state.posChoice && state.posChoice[f.prop]) || 0;
      base = f.variants[pi] || f.variants[0];
    } else {
      base = f.variants[(f.fontOptions ? 0 : i)] || f.variants[0];
    }
    if (f.fontOptions) {
      var o = f.fontOptions[i] || f.fontOptions[0];
      if (f.variantsKind !== 'position' && f.variants.length > 1) {
        base = f.variants[o.variantIdx] || base;
      }
      var fitEx = TUNE.fit && TUNE.fit[String(CFG.productId)];
      var boost = (TUNE.elegantBoost && o.name === 'Elegant' && !(fitEx && fitEx.boost === false)) ? TUNE.elegantBoost : 1;
      if (o.file !== base.font || o.scale !== 1 || boost !== 1) {
        var clone = Object.create(base);
        clone.font = o.file;
        clone.size = base.size * o.scale * boost;
        return clone;
      }
    } else if (f._groupScale && (f._groupScale !== 1 || f._groupFontName === 'Elegant')) {
      var gFitEx = TUNE.fit && TUNE.fit[String(CFG.productId)];
      var gBoost = (TUNE.elegantBoost && f._groupFontName === 'Elegant' && !(gFitEx && gFitEx.boost === false)) ? TUNE.elegantBoost : 1;
      var sc = Object.create(base);
      sc.size = base.size * f._groupScale * gBoost;
      return sc;
    }
    return base;
  }

  function ensureBaseImage(file, cb) {
    if (baseImg && baseImgFile === file) return cb(baseImg);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { baseImg = img; baseImgFile = file; cb(img); };
    img.onerror = function () { cb(null); };
    img.src = CFG.assetBase + file;
  }

  // MC 3.48 (Claude 2026-10-05): fetch every view's base photo once (same
  // crossOrigin mode as ensureBaseImage so the browser cache is reused) —
  // used by the bangle placement pills before the first click
  function preloadBaseImages() {
    if (state._basesPreloaded) return;
    state._basesPreloaded = true;
    var seen = {};
    fields.forEach(function (f) {
      if (f.kind === 'select' || f.kind === 'upload') return;
      (f.variants || []).forEach(function (v) {
        var b = v.baseImage;
        if (!b || b === 'a.png' || b === 'blank.png' || seen[b]) return;
        seen[b] = 1;
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.src = CFG.assetBase + b;
      });
    });
  }

  var renderQueued = false;
  var drawSeq = 0; // MC 3.48: newest draw() wins (see draw)
  // ATC needs to know when the canvas REALLY holds the final scene (the base
  // photo arrives via an async fetch) - callbacks queued here run two frames
  // after the next full paint, so toBlob copies what the customer approved.
  var _drawDoneCbs = [];
  function onDrawComplete(cb) { _drawDoneCbs.push(cb); }
  function flushDrawComplete() {
    if (!_drawDoneCbs.length) return;
    var cbs = _drawDoneCbs; _drawDoneCbs = [];
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      cbs.forEach(function (c) { try { c(); } catch (err) {} });
    }); });
  }

  function render() {
    if (renderQueued) return;
    renderQueued = true;
    var fired = false;
    function go() { if (fired) return; fired = true; renderQueued = false; draw(); }
    requestAnimationFrame(go);
    setTimeout(go, 120); // rAF is paused in background tabs — keep preview live
  }

  function draw() {
    if (!previewCtx) return;
    // The gallery (swiper) may re-render/detach our canvas. Re-mount onto the
    // live main image via the same finder — NEVER insert a second inline image
    // (that caused the duplicate photo under the options on mobile).
    if (previewCanvas && !previewCanvas.isConnected) {
      document.querySelectorAll('.mc-preview-wrapper').forEach(function (w) {
        if (!w.contains(previewCanvas)) w.remove();
      });
      var imgBox2 = findImgBox();
      if (imgBox2) mountPreview(imgBox2, previewCanvas.parentElement);
      // do NOT return if unmounted — we still PAINT the canvas below so the mobile
      // "view your jewelry" button/snapshot shows the engraving even when the
      // overlay hasn't mounted on the main image yet.
    } else if (previewCanvas && previewCanvas.isConnected) {
      // mounted, but the host may have gone hidden (mobile↔desktop breakpoint,
      // swiper slide swap) — move the overlay onto the currently visible image
      var hostBox = previewCanvas.parentElement.parentElement;
      if (hostBox && hostBox.offsetParent === null) {
        var nb = findImgBox();
        if (nb && nb !== hostBox) mountPreview(nb, previewCanvas.parentElement);
      }
    }
    // base image: first ACTIVE text/ghost field's baseImage (in Begge mode the
    // active fields carry the two-view composite photo — the hidden 'ABC'
    // field's single-view photo must not win)
    var base = currentBase();
    // Overlay behavior (parity with the previous app): the main product photo
    // is replaced by the live preview as soon as the customer personalizes.
    var hasContent = personalizationHasContent();
    // MC 3.48: a picked bangle placement (Indvendig/Udvendig/Begge) also
    // shows the preview, so the customer sees that side before typing
    var showOverlay = hasContent || !!state.placementPicked;
    var wrapperEl = previewCanvas && previewCanvas.parentElement;
    var isOverlay = !!(wrapperEl && wrapperEl.classList.contains('mc-preview-overlay') && previewCanvas.isConnected);
    if (isOverlay) {
      if (!showOverlay) wrapperEl.style.display = 'none';
      else if (hasContent) {
        wrapperEl.style.display = '';
        if (wrapperEl._mcFit) wrapperEl._mcFit();
      }
      // placement-only: revealed after the new side's photo is painted
      // (below), so the previously shown side never flashes
    }
    // the mobile "view your jewelry" button only appears once there's content
    if (previewBtn) previewBtn.classList.toggle('mc-has-content', hasContent);
    // MC 3.48: quick Indvendig → Udvendig → Begge clicks can finish their
    // photo loads out of order — only the newest draw may paint
    var seq = ++drawSeq;
    // always paint (even if the overlay isn't mounted) so the preview button works
    ensureBaseImage(base, function (img) {
      if (seq !== drawSeq) return;
      if (isOverlay && showOverlay && !hasContent && previewCanvas.isConnected) {
        // paint first, then reveal (same frame — no stale side visible)
        paintScene(previewCtx, img, state.cropImage);
        wrapperEl.style.display = '';
        if (wrapperEl._mcFit) wrapperEl._mcFit();
        flushDrawComplete();
        return;
      }
      // F6: customer typed before the deferred faces resolved — paint the base
      // photo only (never fallback-font text) and repaint once the fonts land.
      if (hasContent && !fontsReadyDone) {
        ensureFontsLoaded().then(render);
        paintScene(previewCtx, img, state.cropImage, true);
        return; // final paint comes after the fonts land - callbacks stay queued
      }
      paintScene(previewCtx, img, state.cropImage);
      flushDrawComplete();
    });
  }

  // the base jewelry photo for the current (active) field state
  function currentBase() {
    for (var i = 0; i < fields.length; i++) {
      if (fields[i]._active === false) continue;
      if (fields[i].kind === 'select' || fields[i].kind === 'upload') continue;
      var bi = activeVariant(fields[i]).baseImage;
      if (bi && bi !== 'a.png' && bi !== 'blank.png') return bi;
    }
    // last resort: ANY meta's real photo — some products keep the photo on
    // selector/ghost rows while text rows carry placeholders
    for (var j = 0; j < fields.length; j++) {
      var vs = fields[j].variants || [];
      for (var k2 = 0; k2 < vs.length; k2++) {
        var b2 = vs[k2].baseImage;
        if (b2 && b2 !== 'a.png' && b2 !== 'blank.png') return b2;
      }
    }
    return '';
  }

  // hi-DPI backing scale for the preview canvases — renders the whole preview
  // (jewelry + small engraving) at 2× so it stays SHARP when scaled down,
  // without altering any 600-space geometry or stroke weight. Capped at 2×
  // because the base jewelry assets are 1000px (3× would upscale/soften them).
  function previewScale() { return 2; }

  // paint base + engraving text + (optional) uploaded-photo crop in 600-logical
  // space. Shared by the on-page preview and the cropper modal's live pane. The
  // canvas backing may be 600×scale (hi-DPI) — we scale the context so all the
  // 600-based math is unchanged but output is rendered at full backing res.
  function paintScene(ctx, img, cropSrc, skipText) {
    var s = ctx.canvas.width / CANVAS;
    ctx.setTransform(s, 0, 0, s, 0, 0);
    ctx.clearRect(0, 0, CANVAS, CANVAS);
    if (img) {
      ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, CANVAS, CANVAS);
    } else {
      ctx.fillStyle = '#f4efe9';
      ctx.fillRect(0, 0, CANVAS, CANVAS);
    }
    fields.forEach(function (f) {
      if (skipText) return; // F6: fonts not resolved yet — base photo only, repaint follows
      if (f.kind === 'select' || f.kind === 'upload') return;
      if (f.kind === 'ghost') return; // selector-UI layers (e.g. 🖊️ 'A B C') are not engravings
      if (f._active === false) return;
      var v = activeVariant(f);
      var text = state.values[f.prop] || '';
      var ghost = false;
      if (f.kind === 'text' && !text && v.placeholderDefault) { text = v.placeholderDefault; ghost = true; }
      if (!text) return;
      drawText(ctx, text, v, ghost);
    });
    // uploaded handwriting/photo: draw the CROPPED region into the field's box
    // (Zepto: source rect = crop, dest = col2/col3 centre, col4×col14 size,
    // rotated by the field's angle col11). Engraving strokes are already the
    // brown engraving colour on transparent (whiteToTransparent) and drawn with
    // the same multiply blend as the text so it reads as an engraving.
    // EVERY upload field draws its OWN crop (two-necklace sets have Billede 1
    // + Billede 2 — a single shared crop previously showed handwriting on only
    // one pendant). cropSrc, when given (cropper live-preview), overrides the
    // LAST-OPENED field's stored crop.
    fields.forEach(function (f) {
      if (f.kind !== 'upload') return;
      var src = f._cropImage || null;
      if (cropSrc && (cropSrc._mcFld === f || (!cropSrc._mcFld && !src))) src = cropSrc;
      if (!src) return;
      var uf = activeVariant(f);
      var sw = src.naturalWidth || src.width;
      var sh = src.naturalHeight || src.height;
      var bw = CANVAS * ((uf.w || 30) / 100);
      var bh = uf.ratio ? CANVAS * (uf.ratio / 100) : bw * (sh / sw);
      // Zepto (cropper-spec §5): x (col2) = horizontal CENTRE, y (col3) = box
      // TOP, size col4×col14 — the same col3=top convention the text uses and
      // the 76-product sweep validated. So the box top-left is (cx - bw/2, yTop).
      var cx = CANVAS * (uf.x / 100);
      var yTop = CANVAS * (uf.y / 100);
      var left = cx - bw / 2;
      var engrave = src._mcEngrave; // brown-on-transparent (preview) vs raw
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      if (ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = 'high';
      if (uf.angle) {
        var pcx = cx, pcy = yTop + bh / 2; // rotate about the box centre
        ctx.translate(pcx, pcy); ctx.rotate(uf.angle * Math.PI / 180); ctx.translate(-pcx, -pcy);
      }
      // draw the crop at its TRUE weight (no thickening) — sharpness comes
      // from the hi-DPI backing + high-quality smoothing, not from dilation.
      // Engraving crops get the same 3-layer deboss as text.
      if (engrave) {
        if (!src._mcDark) {
          src._mcDark = tintStrokes(src, 46, 28, 10, 0.32);
          src._mcLight = tintStrokes(src, 255, 255, 255, 0.7);
        }
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
        ctx.drawImage(src._mcDark, left, yTop - 1.0, bw, bh);
        ctx.drawImage(src._mcLight, left, yTop + 1.4, bw, bh);
        ctx.globalCompositeOperation = 'multiply';
      }
      ctx.drawImage(src, left, yTop, bw, bh);
      ctx.restore();
    });
  }

  function drawText(ctx, text, v, ghost) {
    // LAYOUT-ONLY normalisation: a variation selector forces the OS colour-
    // emoji face (U+2665+VS16 rendered as a RED heart on gold - 9 orders).
    // The order property keeps the customer's exact string; only the drawing
    // pipeline sees the stripped text.
    if (TUNE.symbolNormalize && text) {
      text = String(text).replace(/[\uFE0E\uFE0F]/g, '');
      // the house fonts draw U+2665 as a SOLID heart and U+267E as a blob -
      // map both onto the outline glyphs every other order gets (2764 / 221E)
      text = text.replace(/\u2665/g, '\u2764').replace(/\u267E/g, '\u221E');
    }
    ctx.save();
    var fam = fontFamilies[v.font] || 'sans-serif';
    // Zepto (canvas-script v2): fSize = ratio(col14) * pss(col1) * 0.75 * (canH/500) pt
    // → px = ratio * pss * (canvasHeight/500)  [0.75pt→px cancels: 0.75 * 4/3 = 1]
    var px = v.size * (CANVAS / 500) * FONT_K * (FONT_SIZE_ADJUST[v.font] || 1);
    var FIT = (TUNE.fit && TUNE.fit[String(CFG.productId)]) || null;
    var isElegantFaceEarly = /elegant|a67|alto/i.test(String(v.font || ''));
    // K1: Moderne fylder mere end Elegant ved samme boks - flerlinjede blokke
    // en anelse ned, saa 2-linjers ikke dominerer vedhaenget
    if (TUNE.moderneMultiScale && !isElegantFaceEarly && text.indexOf('\n') >= 0) px *= TUNE.moderneMultiScale;
    // Shrink-to-fit (Zepto behavior): the flat text width may not exceed the
    // field's box width (col4 % of canvas). Long texts scale down — without this,
    // couples/pair texts render 3-8× oversized and clip (testers B/C/E).
    var stack = '"' + fam + '", "Helvetica Neue", Helvetica, Arial, sans-serif';
    var weight = ''; // Zepto set no weight — system regular matches export metrics
    var boxW = CANVAS * (v.w / 100);
    if (FIT && FIT.wScale) boxW *= FIT.wScale;   // P01/P02: bredde-loft inde fra pladekanten
    var isRTL = /[؀-ۿݐ-ݿ]/.test(text);
    // Curved text (Zepto col5): diameter = col5 * canvasHeight/500; <0 = inward.
    // col5 == 500 is Zepto's DEFAULT/sentinel (a weight field), NOT a curve —
    // real curves in this catalog are ±1900/2500. Routing 500 through the arc
    // path mis-anchored every flat pendant/plate product (requalify audit).
    // Zepto curves ONLY when type (col10) > 2 (canvas-script: 1=plain,
    // 2=rotatable, >2=curved) — col5 diameters on plain fields are leftovers
    // and must render FLAT: all bar/ocean-waves pair bracelets carry -1900 at
    // type 1 and Zepto draws them straight (Jonas 2026-07-07, SE screenshot).
    // Editor overrides that set spacing explicitly still force the arc.
    var curveOn = parseFloat(v.typeCode) > 2 || v._spacingForced;
    var rawSpacing = (!curveOn || v.spacing === 500) ? 0 : (v.spacing || 0);
    var diameter = rawSpacing * (CANVAS / 500);
    // symbols/emoji outside the letter range render as thin outlines that
    // disappear at engraving opacity — the ink pass strokes them slightly.
    // Emoji are scaled to CAP HEIGHT and optically centred (Jonas). Monograms
    // ('A ♡ B', 'L + D', 'M ∞ K') lay out symmetrically from INK extents —
    // font advances put the symbol off-centre because the Elegant capitals
    // carry negative right-side bearings (the swash-overlap spacing fix).
    var EMOJI_RE = /[☀-➿⬀-⯿\u{1F000}-\u{1FAFF}]/u;
    var MONO_RE = /^([A-ZÆØÅ])(\s*)([♡♥❤+&∞×])(\s*)([A-ZÆØÅ])$/u;
    function setFont(scale) {
      ctx.font = weight + (px * (scale || 1)) + 'px ' + stack;
    }
    var _capM = null;
    function capMetrics() {
      if (!_capM) {
        var m = ctx.measureText('H');
        var asc = m.actualBoundingBoxAscent || px * 0.7;
        var desc = m.actualBoundingBoxDescent || 0;
        _capM = { h: asc + desc, c: (desc - asc) / 2 };
      }
      return _capM;
    }
    // scale + vertical shift that makes an emoji glyph exactly cap-high and
    // centred on the capitals' optical middle
    function emojiFit(g) {
      var m = ctx.measureText(g);
      var asc = m.actualBoundingBoxAscent || px * 0.5;
      var desc = m.actualBoundingBoxDescent || 0;
      var h = asc + desc || px * 0.5;
      var cm = capMetrics();
      var sc = Math.max(0.5, Math.min(2.5, cm.h / h));
      return { scale: sc, dy: cm.c - ((desc - asc) / 2) * sc };
    }
    function liftFor(ch) {
      if (/[+&∞×]/.test(ch)) return -px * 0.10; // math/amp sit low vs caps
      return 0;
    }
    function segW(g) {
      if (EMOJI_RE.test(g)) {
        var fit = emojiFit(g);
        setFont(fit.scale);
        var w2 = ctx.measureText(g).width;
        setFont(1);
        return w2;
      }
      return ctx.measureText(g).width;
    }
    // symbols that must never touch a letter (Jonas review: 25/159 notes) -
    // hearts in the emoji ranges plus the separator glyphs + & x and infinity
    var SYM_RE = /[\u2661\u2665\u2764+&\u00D7\u221E]/;
    var ALNUM_RE = /[0-9A-Za-z\u00C0-\u024F]/;
    var CAP_RE = /[A-Z\u00C6\u00D8\u00C5\u00C4\u00D6\u00DC]/;
    var isElegantFace = /elegant|a67|alto/i.test(String(v.font || ''));
    function isSpacerG(g) { return SYM_RE.test(g) || EMOJI_RE.test(g); }
    /* v2 (Jonas 2026-09-05): all spacing decisions are made on INK, not on
       advance cells. The Elegant capitals' swash runs far PAST their advance,
       so cell-based padding let 'A\u2661' overlap and cell-based centring put a
       spaced heart nearer the date than the letter. Rules:
         - between a symbol and adjacent letter ink: gap >= 0.12em
         - between two Elegant CAPITALS: ink gap >= 0.08em (their negative
           right-side bearing is designed for the lowercase tuck, not caps)
         - a symbol with letters on BOTH sides is shifted so the two ink gaps
           are EQUAL - 'precisely between', as typed
         - capital->lowercase stays untouched (the swash tuck is the design) */
    function segLayout(line) {
      var gs = graphemes(line);
      var it = gs.map(function (g) {
        var isE = EMOJI_RE.test(g);
        var fit = isE ? emojiFit(g) : null;
        if (fit) setFont(fit.scale);
        var m = ctx.measureText(g);
        var w = m.width;
        var iL = (m.actualBoundingBoxLeft != null) ? -m.actualBoundingBoxLeft : 0;   // ink start rel. origin
        var iR = (m.actualBoundingBoxRight != null) ? m.actualBoundingBoxRight : w;  // ink end rel. origin
        if (fit) setFont(1);
        return { g: g, w: w, iL: iL, iR: iR, dx: 0, padL: 0, padR: 0, _fit: fit,
                 sym: isSpacerG(g), alnum: ALNUM_RE.test(g), cap: CAP_RE.test(g),
                 space: !g.trim() };
      });
      // 3.81: Elegant's 0.41em space shrinks to TUNE.elegantSymbolSpace of
      // its width when it sits next to a symbol (see TUNE)
      var symSp = (isElegantFace && TUNE.elegantSymbolSpace < 1) ? TUNE.elegantSymbolSpace : 1;
      if (symSp < 1) mcSymSpaces(it).forEach(function (si) { it[si].padR = -(1 - symSp) * it[si].w; });
      if (TUNE.symbolBearings) {
        var GAP_SYM = px * 0.12, GAP_CAP = px * 0.08;
        // pass 1: expand pads so ink never collides (walk left->right)
        var cur = 0, prevInkEnd = null, prevIdx = -1;
        for (var i2 = 0; i2 < it.length; i2++) {
          var o = it[i2];
          cur += o.padL;
          if (prevInkEnd != null && !o.space) {
            var need = 0, pv = it[prevIdx];
            if ((o.sym && pv.alnum) || (pv.sym && o.alnum)) need = GAP_SYM;
            else if (isElegantFace && o.cap && pv.cap) need = GAP_CAP;
            if (need) {
              var gap = (cur + o.dx + o.iL) - prevInkEnd;
              if (gap < need) { var add = need - gap; o.padL += add; cur += add; }
            }
          }
          if (!o.space) { prevInkEnd = cur + o.dx + o.iR; prevIdx = i2; }
          cur += o.w + o.padR;
        }
        // pass 2 v3 (Jonas '\u2661 29.09.09 \u2661'): a typed space next to a symbol is
        // an INK promise, not an advance - the gap symbol<->digit must measure
        // spaces x spaceWidth on the visible ink, identically in both ends.
        // Elegant digits carry swash tails past their advance, which made the
        // trailing gap visibly tighter than the leading one.
        var spW2 = ctx.measureText(' ').width * symSp; // 3.81: shrunk Elegant symbol space
        var pos = [], run = 0;
        it.forEach(function (o) { run += o.padL; pos.push(run); run += o.w + o.padR; });
        for (var i3 = 0; i3 < it.length; i3++) {
          var oS = it[i3];
          if (!oS.sym) continue;
          var li = i3 - 1, nspL = 0; while (li >= 0 && it[li].space) { li--; nspL++; }
          var ri = i3 + 1, nspR = 0; while (ri < it.length && it[ri].space) { ri++; nspR++; }
          var hasL = li >= 0 && it[li].alnum, hasR = ri < it.length && it[ri].alnum;
          if (!hasL && !hasR) continue;
          var useOpt = TUNE.opticalSpacing;
          var fontOf = function (o2) {
            return o2._fit ? (weight + (px * o2._fit.scale) + 'px ' + stack) : (weight + px + 'px ' + stack);
          };
          var dyOf = function (o2) { return o2._fit ? o2._fit.dy : 0; };
          var gapTo = function (ai, bi2) {
            // distance between origins incl. current pads/dx
            var dist = (pos[bi2] + it[bi2].dx) - (pos[ai] + it[ai].dx);
            if (!useOpt) return null;
            return mcOpticalGap(fontOf(it[ai]), it[ai].g, dyOf(it[ai]),
                                fontOf(it[bi2]), it[bi2].g, dyOf(it[bi2]), dist);
          };
          var tgt = function (n, capNb) {
            if (useOpt) return n > 0 ? n * spW2 + px * 0.06 : px * 0.30;   // MEAN air target
            return n > 0 ? n * spW2 : px * (capNb ? 0.20 : 0.12);
          };
          var gL = null, gR = null, tL = 0, tR = 0, oL = null, oR = null;
          if (hasL) {
            oL = gapTo(li, i3);
            gL = (oL && oL.mean != null) ? oL.mean
               : (pos[i3] + oS.dx + oS.iL) - (pos[li] + it[li].dx + it[li].iR);
            tL = tgt(nspL, it[li].cap);
          }
          if (hasR) {
            oR = gapTo(i3, ri);
            gR = (oR && oR.mean != null) ? oR.mean
               : (pos[ri] + it[ri].dx + it[ri].iL) - (pos[i3] + oS.dx + oS.iR);
            tR = tgt(nspR, it[ri].cap);
          }
          var shift = 0;
          if (hasL && hasR) shift = ((tL - gL) - (tR - gR)) / 2;  // equal deviation both sides
          else if (hasL) shift = tL - gL;
          else shift = gR - tR;
          // never let the closest points collide: bound the shift by min-gap floors
          var FLOOR = px * 0.09;
          if (useOpt) {
            if (hasL && oL && oL.min != null) shift = Math.max(shift, FLOOR - oL.min);
            if (hasR && oR && oR.min != null) shift = Math.min(shift, oR.min - FLOOR);
          }
          oS.dx += shift;
        }
      }
      var tot = 0;
      it.forEach(function (o) { tot += o.padL + o.w + o.padR; });
      return { items: it, total: tot };
    }
    function monoLayout(mm) {
      var parts = [mm[1], mm[3], mm[5]];
      var inks = parts.map(function (t) {
        var isE = EMOJI_RE.test(t);
        var fit2 = isE ? emojiFit(t) : null;
        if (fit2) setFont(fit2.scale);
        var m2 = ctx.measureText(t);
        var L = m2.actualBoundingBoxLeft || 0;
        var R = m2.actualBoundingBoxRight || m2.width;
        if (fit2) setFont(1);
        return { L: L, R: R, w: L + R };
      });
      var spW = ctx.measureText(' ').width;
      // 3.81: Elegant's space is 0.41em - 'A + B' read as three loose letters
      if (isElegantFace && TUNE.elegantSymbolSpace < 1) spW *= TUNE.elegantSymbolSpace;
      var typed = Math.max((mm[2] || '').length, (mm[4] || '').length);
      // typed spacing wins: 'A&L' entered tight stays tight (floor 0.14em) and
      // a roomy Elegant space no longer yawns (cap 0.42em) - review #26856/#26831
      var gap = TUNE.symbolBearings
        ? Math.min(Math.max(typed * spW, px * 0.14), px * 0.42)
        : spW * ((mm[2] || ' ').length || 1);
      return { parts: parts, inks: inks, gap: gap,
               total: inks[0].w + gap + inks[1].w + gap + inks[2].w };
    }
    function needsSegments(line) {
      if (isRTL) return false;
      if (EMOJI_RE.test(line) || MONO_RE.test(line)) return true;
      if (!TUNE.symbolBearings) return false;
      // 'A+K 30.07.26' (separator with touching bearings) and Elegant
      // capital-pairs ('KV', 'MOR') both need the ink-gap layout
      if (SYM_RE.test(line) && ALNUM_RE.test(line)) return true;
      return !!(isElegantFace && /[A-Z\u00C6\u00D8\u00C5\u00C4\u00D6\u00DC]{2}/.test(line));
    }
    // true drawn width of a segmented line — emoji upscale to cap height and
    // glyphs advance per-grapheme (string kerning lost), so plain measureText
    // under-reads and the shrink pass let hearts spill past narrow bar plates
    function segLineWidth(line) {
      var mm = MONO_RE.exec(line);
      if (mm) return monoLayout(mm).total;
      return segLayout(line).total;
    }
    // middle-baseline BEFORE any measurement: actualBoundingBox* metrics are
    // relative to the ACTIVE textBaseline, and capMetrics caches the capitals'
    // optical centre during the shrink pass below. Measured under the default
    // alphabetic baseline but drawn under 'middle', that cached centre floated
    // emoji ~0.3em above short lines — only no-shrink paths kept the stale
    // cache, which is why long test texts never showed it (Jonas 2026-07-14,
    // SE heart pendant "Hej ♡").
    ctx.textBaseline = 'middle';
    var lineTrack = null;
    if (boxW > 0) {
      ctx.font = weight + px + 'px ' + stack;
      var arcMode = diameter && Math.abs(diameter) > px * 4 && !isRTL;
      var canTrack = TUNE.softTracking && ('letterSpacing' in ctx) && !isRTL && !arcMode;
      var infos = text.split('\n').map(function (ln) {
        var seg = !arcMode && needsSegments(ln);
        var mw = seg ? segLineWidth(ln) : ctx.measureText(ln).width;
        var n = graphemes(ln).length;
        // rescue budget: tighten tracking instead of shrinking (plain lines only -
        // the segmented layout owns its own gaps via the bearing floors)
        var gain = (canTrack && !seg && n > 1) ? TUNE.softTracking * px * (n - 1) : 0;
        return { w: mw, eff: Math.max(mw - gain, 0), n: n, seg: seg };
      });
      var effWidest = 0;
      infos.forEach(function (o) { if (o.eff > effWidest) effWidest = o.eff; });
      if (effWidest > boxW) { px = px * (boxW / effWidest); _capM = null; }
      // per-line tracking at the FINAL px: exactly enough to reach the cap
      ctx.font = weight + px + 'px ' + stack;
      if (canTrack) {
        lineTrack = infos.map(function (o, li2) {
          if (o.seg || o.n < 2) return 0;
          var ln2 = text.split('\n')[li2];
          var w2 = ctx.measureText(ln2).width;
          if (w2 <= boxW) return 0;
          return Math.min((w2 - boxW) / (o.n - 1), TUNE.softTracking * px);
        });
        if (!lineTrack.some(function (t2) { return t2 > 0; })) lineTrack = null;
      }
    }
    ctx.font = weight + px + 'px ' + stack;
    var boxH = CANVAS * ((v.ratio || 0) / 100);
    var lines = text.split('\n');
    // line height: Zepto multiplies col28 by the font's DOM em box (ascent +
    // descent — font-dependent: script faces are taller), not by px directly.
    // px-based lh rendered 2-3-line blocks 15-35% too tight.
    function measureFontBox() {
      var mm = ctx.measureText('Hgf');
      var fb = (mm.fontBoundingBoxAscent || 0) + (mm.fontBoundingBoxDescent || 0);
      return fb > 0 ? fb : px * 1.2;
    }
    var fontBox = measureFontBox();
    // NO block-height shrink: Zepto's fitting loop constrains WIDTH only
    // (their source measures textHeight but never shrinks on it — verified
    // against canvas-script-v2 + customer preview #25324). Short 2-line
    // texts ('Jeg/Dig') keep full size like live; long lines still scale
    // down gradually via the width pass above (Jonas 2026-07-06).
    var lh = fontBox * (v.lineHeight || 1.2);
    var tone = FONT_TONE[v.font];
    ctx.fillStyle = ghost ? '#838388'
      : (tone && tone.lighten ? lightenColor(v.color, tone.lighten) : v.color);
    if (!ghost) {
      // engraving tone: multiply blend, strength scaled by Zepto's per-layer
      // opacity col12 (alpha = 1 - col12/127) relative to the necklace default
      // 0.449 the 0.8 constant was tuned against
      var a12 = isNaN(v.alpha12) ? 0.449 : (1 - v.alpha12 / 127);
      ctx.globalCompositeOperation = 'multiply';
      ctx.globalAlpha = Math.max(0.4, Math.min(1, 0.8 * (a12 / 0.449)));
    }
    var x = CANVAS * (v.x / 100);
    // Zepto anchors y at the TOP of the field's text box (height = col14 % of
    // canvas) with the text centered inside — not at the text's own midline.
    var vInkOn = !!(TUNE.inkVCenter && FIT && FIT.vInk);
    var yTop = CANVAS * (v.y / 100) + ((FIT && FIT.dy && !vInkOn) ? FIT.dy * (CANVAS / 600) : 0);
    var y = yTop + boxH / 2; // straight text: centered inside the box
    if (v.angle) {
      ctx.translate(x, y); ctx.rotate(v.angle * Math.PI / 180); ctx.translate(-x, -y);
    }
    // RTL (Arabic): draw whole string; browser shapes glyphs correctly
    if (isRTL) {
      ctx.direction = 'rtl';
    }
    var y0 = y - ((lines.length - 1) * lh) / 2;
    if (vInkOn && boxH > 0) {
      // rev9b (Jonas' domme): OPTISK blaek-centrering - underlaengder taeller
      // kun 45% (de laeses som haler, ikke krop), og hele blokken faar et lille
      // loeft (oejets midte ligger over den geometriske). Dermed beholder
      // 'anne og mee' sit gamle leje, mens 'gry pyt jyp' ikke haenger lavt.
      var DESC_W = 0.45, SYMV_W = 0.5, V_BIAS = 0.035;
      var kBase = ctx.measureText('x').actualBoundingBoxDescent || 0; // midt->grundlinje
      // rev9c ('\u266130.07.2026\u2661' for lav): symbolerne maa ikke styre linjen -
      // deres blaek ud over TEKSTENS baand taeller kun halvt, ellers trykker et
      // hoejt hjerte tallene ned under midten
      var inkTop = null, inkBot = null;
      lines.forEach(function (ln9, i9) {
        var cy9 = y0 + i9 * lh;
        var aT = null, aB = null, sT = null, sB = null;   // alnum-baand / symbol-baand
        if (needsSegments(ln9)) {
          graphemes(ln9).forEach(function (g9) {
            var isS9 = SYM_RE.test(g9) || EMOJI_RE.test(g9);
            var fit9 = EMOJI_RE.test(g9) ? emojiFit(g9) : null;
            if (fit9) setFont(fit9.scale);
            var m9 = ctx.measureText(g9);
            var top9 = (fit9 ? fit9.dy : 0) - (m9.actualBoundingBoxAscent || px * 0.7);
            var bot9 = (fit9 ? fit9.dy : 0) + (m9.actualBoundingBoxDescent || 0);
            if (fit9) setFont(1);
            if (isS9) {
              if (sT === null || top9 < sT) sT = top9;
              if (sB === null || bot9 > sB) sB = bot9;
            } else if (g9.trim()) {
              if (aT === null || top9 < aT) aT = top9;
              if (aB === null || bot9 > aB) aB = bot9;
            }
          });
        } else {
          var mL9 = ctx.measureText(ln9);
          aT = -(mL9.actualBoundingBoxAscent || px * 0.7);
          aB = (mL9.actualBoundingBoxDescent || 0);
        }
        if (aT === null) { aT = sT; aB = sB; sT = sB = null; }  // ren symbol-linje
        if (aT === null) return;
        var eb9 = (aB > kBase) ? kBase + DESC_W * (aB - kBase) : aB; // daemp underlaengder
        var t9 = aT, b9 = eb9;
        if (sT !== null && sT < t9) t9 = t9 - SYMV_W * (t9 - sT);    // symbol-overskud: halv vaegt
        if (sB !== null && sB > b9) b9 = b9 + SYMV_W * (sB - b9);
        if (inkTop === null || cy9 + t9 < inkTop) inkTop = cy9 + t9;
        if (inkBot === null || cy9 + b9 > inkBot) inkBot = cy9 + b9;
      });
      if (inkTop !== null) y0 += (yTop + boxH / 2 - V_BIAS * boxH) - (inkTop + inkBot) / 2;
    }
    if (FIT && FIT.hLift && boxH > 0 && lines.length === 1) {
      // P03 rev4: en descender maa ikke stikke ud af den lave plade - LOEFT
      // linjen op i det frie rum foroven i stedet for at skalere den ned
      var mh = ctx.measureText(lines[0]);
      var over = (y0 + (mh.actualBoundingBoxDescent || 0)) - (yTop + boxH - 1);
      if (over > 0) {
        var room = (y0 - (mh.actualBoundingBoxAscent || px * 0.7)) - (yTop + 1);
        y0 -= Math.min(over, Math.max(0, room));
      }
    }
    function drawGlyph(g, gx, gy, inkPass, extraDy) {
      var isEmoji = EMOJI_RE.test(g);
      var fit = isEmoji ? emojiFit(g) : null;
      if (fit) setFont(fit.scale);
      var yy = gy + (fit ? fit.dy : 0) + (extraDy || 0);
      ctx.fillText(g, gx, yy);
      // stroke ONLY true pictographs (>= U+1F000): their hairline outlines
      // vanish at engraving opacity. The BMP symbols (hearts, infinity, stars)
      // are the house font's own glyphs at LETTER weight - stroking them made
      // the heart read bolder than the text (Jonas rev4: 'same line thickness
      // as the letters').
      var strokeIt = isEmoji && (TUNE.strokeBmpSymbols || g.codePointAt(0) >= 0x1F000);
      if (inkPass && strokeIt) {
        ctx.save();
        ctx.strokeStyle = ctx.fillStyle;
        ctx.lineWidth = px * 0.02;
        ctx.strokeText(g, gx, yy);
        ctx.restore();
      }
      if (fit) setFont(1);
    }
    function drawSegmented(line, cx0, cy, inkPass) {
      var oldAlign = ctx.textAlign;
      ctx.textAlign = 'left';
      var mm = MONO_RE.exec(line);
      if (mm) {
        // symmetric monogram: ink widths, one equal gap on each side
        var lay = monoLayout(mm);
        var cur = cx0 - lay.total / 2;
        lay.parts.forEach(function (t, ti) {
          drawGlyph(t, cur + lay.inks[ti].L, cy, inkPass,
            EMOJI_RE.test(t) ? 0 : (ti === 1 ? liftFor(t) : 0));
          cur += lay.inks[ti].w + (ti < 2 ? lay.gap : 0);
        });
      } else {
        var lay2 = segLayout(line);
        var sx = cx0 - lay2.total / 2;
        lay2.items.forEach(function (o) {
          sx += o.padL;
          drawGlyph(o.g, sx + o.dx, cy, inkPass, (!EMOJI_RE.test(o.g) ? liftFor(o.g) : 0));
          sx += o.w + o.padR;
        });
      }
      ctx.textAlign = oldAlign;
    }
    var drawPass = function (dy, inkPass) {
      lines.forEach(function (line, i) {
        if (diameter && Math.abs(diameter) > px * 4 && !isRTL) {
          // per-character arc breaks Arabic contextual joining — RTL draws flat.
          // Anchor: box-top + px*0.35 (order-PNG validated on inward arcs).
          // OUTWARD arcs (positive col5) sat 5px@600 high vs Zepto with that
          // anchor (all smooth +1900 / bar-til-mænd +2500, sweep 2026-07-06) —
          // baseline sits differently when text bows down: +0.24·px more.
          drawArcLine(ctx, line, x, yTop + (y0 - y) + i * lh + px * (rawSpacing > 0 ? 0.59 : 0.35) + dy, diameter, px, inkPass);
        } else if (needsSegments(line)) {
          drawSegmented(line, x, y0 + i * lh + dy, inkPass);
        } else {
          ctx.textAlign = (v.align === 'center' || !v.align) ? 'center' : v.align;
          var tr = lineTrack && lineTrack[i];
          if (tr) { try { ctx.letterSpacing = (-tr) + 'px'; } catch (e2) {} }
          ctx.fillText(line, x, y0 + i * lh + dy, CANVAS * (v.w / 100) * 1.6);
          if (tr) { try { ctx.letterSpacing = '0px'; } catch (e3) {} }
        }
      });
    };
    if (!ghost) {
      // engraved (deboss) illusion, three layers like a real groove lit from
      // above: dark upper inner edge, ink, bright lower edge catching light.
      // Highlight/shadow run source-over (multiply eats pure white).
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(46, 28, 10, 0.32)';   // groove depth above
      drawPass(-px * 0.05, false);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'; // light catch below
      drawPass(px * 0.07, false);
      ctx.restore();
    }
    drawPass(0, true);
    ctx.restore();
  }

  // Circular text along an arc, following Zepto's renderer semantics:
  // negative diameter = inward-facing (text bows with the jewelry curve).
  var FONT_K = 1; // Zepto-exact; font-group scale (Elegant 1.18 etc.) applies separately
  var ARC_EMOJI_RE = /[\u2600-\u27BF\u2B00-\u2BFF\u{1F000}-\u{1FAFF}]/u;
  function drawArcLine(ctx, text, x, y, diameter, px, inkPass) {
    var inward = diameter < 0;
    var radius = Math.abs(diameter) / 2;
    var f = radius - px / 2; // radius = |col5 * canH/500| / 2 (Zepto-exact)
    // grapheme clusters, NOT UTF-16 units: split('') halves surrogate-pair
    // emoji (🤍 → two .notdef boxes on arcs)
    var chars = graphemes(text);
    // inward stepping lays glyphs left→right already; OUTWARD (positive col5,
    // e.g. Bangle outside view) steps the opposite way — reverse so the text
    // reads correctly (tester C found "05/09/2026" mirrored to "6202/90/50")
    if (!inward) chars.reverse();
    ctx.save();
    ctx.textAlign = 'center';
    // circle center: below the text line for inward (text on top of circle)
    var cy = inward ? y + f : y - f;
    ctx.translate(x, cy);
    var clockwise = -1;
    // start angle: back up half the total arc width (center alignment)
    var total = 0;
    chars.forEach(function (ch) { total += ctx.measureText(ch).width; });
    var startAngle = (total / f) / 2 * (inward ? 1 : -1);
    var a = startAngle;
    chars.forEach(function (ch) {
      var w = ctx.measureText(ch).width;
      var step = (w / f) * (inward ? 1 : -1) * clockwise;
      a += step / 2;
      ctx.save();
      ctx.rotate(inward ? -a : a);
      var isE = ARC_EMOJI_RE.test(ch);
      var baseY = inward ? -f : f;
      if (isE) {
        // scale emoji to cap height + optically centre (same rule as flat text)
        var mH = ctx.measureText('H');
        var ascH = mH.actualBoundingBoxAscent || px * 0.7;
        var descH = mH.actualBoundingBoxDescent || 0;
        var mE = ctx.measureText(ch);
        var ascE = mE.actualBoundingBoxAscent || px * 0.5;
        var descE = mE.actualBoundingBoxDescent || 0;
        var sc2 = Math.max(0.5, Math.min(2.5, (ascH + descH) / ((ascE + descE) || px * 0.5)));
        var dyE = ((descH - ascH) / 2) - ((descE - ascE) / 2) * sc2;
        var prevFont = ctx.font;
        ctx.font = prevFont.replace(/(\d+(?:\.\d+)?)px/, function (_, n) { return (parseFloat(n) * sc2) + 'px'; });
        ctx.fillText(ch, 0, baseY + dyE);
        if (inkPass) {
          ctx.strokeStyle = ctx.fillStyle;
          ctx.lineWidth = px * 0.02;
          ctx.strokeText(ch, 0, baseY + dyE);
        }
        ctx.font = prevFont;
      } else {
        ctx.fillText(ch, 0, baseY);
      }
      ctx.restore();
      a += step / 2;
    });
    ctx.restore();
  }

  // recolor an engraving stroke image (color-on-transparent) to a flat RGBA —
  // used for the deboss shadow/highlight layers of handwriting/drawing crops
  function tintStrokes(src, r, g, b, a) {
    var c = document.createElement('canvas');
    c.width = src.width || src.naturalWidth;
    c.height = src.height || src.naturalHeight;
    var cx2 = c.getContext('2d');
    cx2.drawImage(src, 0, 0);
    var d = cx2.getImageData(0, 0, c.width, c.height);
    var px2 = d.data;
    for (var i = 0; i < px2.length; i += 4) {
      if (px2[i + 3] === 0) continue;
      px2[i] = r; px2[i + 1] = g; px2[i + 2] = b;
      px2[i + 3] = Math.round(px2[i + 3] * a);
    }
    cx2.putImageData(d, 0, 0);
    return c;
  }

  /* ---------- upload cropper (self-hosted Cropper.js) ---------- */
  // return a copy of a black-on-white canvas with white → transparent and the
  // black strokes recoloured to `tint` (the engraving brown) — so the jewelry
  // preview shows brown engraving instead of harsh black, matching the text
  function whiteToTransparent(src, tint) {
    var rgb = hexToRgb(tint || '#8c603b');
    var c = document.createElement('canvas');
    c.width = src.width; c.height = src.height;
    var ctx = c.getContext('2d');
    ctx.drawImage(src, 0, 0);
    var id = ctx.getImageData(0, 0, c.width, c.height), d = id.data;
    for (var i = 0; i < d.length; i += 4) {
      // already-transparent (crop area beyond the image when zoomed out) or
      // white paper → transparent; only the dark strokes become engraving brown
      if (d[i + 3] < 128 || (d[i] > 200 && d[i + 1] > 200 && d[i + 2] > 200)) { d[i + 3] = 0; }
      else { d[i] = rgb.r; d[i + 1] = rgb.g; d[i + 2] = rgb.b; d[i + 3] = 255; }
    }
    ctx.putImageData(id, 0, 0);
    c._mcEngrave = true; // marks a brown-on-transparent engraving (multiply-blend it)
    return c;
  }
  function hexToRgb(hex) {
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
    return m ? { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) } : { r: 140, g: 96, b: 59 };
  }
  // the current engraving colour — matches an active text field's colour (col6),
  // falls back to the Mon Chou engraving brown
  function engraveColor() {
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.kind === 'text' && f._active !== false) {
        var c = activeVariant(f).color;
        if (c) return c;
      }
    }
    return '#8c603b';
  }

  // lazy-load the self-hosted Cropper.js library (Zepto used the same lib) —
  // only fetched the first time a customer uploads a photo
  var cropperLibState = 0; // 0 idle, 1 loading, 2 ready
  var cropperLibCbs = [];
  function loadCropperLib(cb) {
    if (cropperLibState === 2 || window.Cropper) { cb(); return; }
    cropperLibCbs.push(cb);
    if (cropperLibState === 1) return;
    cropperLibState = 1;
    var css = el('link', null, document.head); css.rel = 'stylesheet';
    css.href = CFG.assetBase + 'mc-cropper.css';
    var s = document.createElement('script');
    s.src = CFG.assetBase + 'mc-cropper.js';
    s.onload = function () {
      cropperLibState = 2;
      cropperLibCbs.forEach(function (fn) { fn(); });
      cropperLibCbs = [];
    };
    document.head.appendChild(s);
  }

  // interactive crop modal — one-to-one with Zepto's Cropper.js flow:
  // resizable rule-of-thirds crop box (aspect-locked to the field's col4:col14
  // box), live jewelry preview on the left, toolbar: delete / rotate CW /
  // rotate CCW / zoom out / zoom in / confirm.
  function openCropper(fld, file, v, cropInput) {
    var grayscale = ((v.raw && v.raw[42]) || '').trim() === '2';
    var aspect = (v.w && v.ratio) ? (v.w / v.ratio) : NaN; // col4/col14 (square canvas)
    var objURL = URL.createObjectURL(file);

    var overlay = el('div', 'mc-crop-modal', document.body);
    var box = el('div', 'mc-crop-box', overlay);
    // close (X) top-right — applies the current crop and closes (non-destructive;
    // the trash button is there to discard). confirmCrop is hoisted.
    var closeBtn = el('button', 'mc-crop-close', box);
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Luk');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); confirmCrop(); });
    var main = el('div', 'mc-crop-main', box);
    // left: live jewelry preview
    var leftPane = el('div', 'mc-crop-left', main);
    var leftCanvas = el('canvas', 'mc-crop-preview', leftPane);
    leftCanvas.width = leftCanvas.height = CANVAS * previewScale(); // hi-DPI → sharp
    var leftCtx = leftCanvas.getContext('2d');
    // right: cropper + (engraving sliders) + toolbar
    var rightPane = el('div', 'mc-crop-right', main);
    var area = el('div', 'mc-crop-area', rightPane);
    var cropImg = el('img', 'mc-crop-img', area);
    // engraving-conversion sliders (only on grayscale-engraving upload fields,
    // col42=2) — turn the photo into black-on-white line-art the engraver uses
    var sliders = grayscale ? el('div', 'mc-crop-sliders', rightPane) : null;
    var bar = el('div', 'mc-crop-bar', rightPane);
    document.body.classList.add('mc-crop-open');

    // Balance    = luminance threshold (imgvector: threshold = 2.56 × balance,
    //              Rec.709 luma → pixel is white when brighter, black when darker).
    // Smoothness = Gaussian blur radius applied BEFORE the threshold, so higher
    //              values round off jagged/noisy stroke edges (0 = raw & sharp).
    var balanceVal = 50, smoothVal = 20;
    var srcCanvas = null; // colour source (capped ≤1400) — re-thresholded per change

    // threshold srcCanvas → black-on-white canvas (same dims). transparentBg=true
    // makes the white background transparent (engraving-on-metal look).
    function thresholdCanvas(transparentBg) {
      if (!srcCanvas) return null;
      var w = srcCanvas.width, h = srcCanvas.height;
      var work = document.createElement('canvas'); work.width = w; work.height = h;
      var wc = work.getContext('2d');
      var blurPx = (smoothVal / 100) * Math.max(1, w / 150); // smoothness → blur
      if (blurPx > 0.15 && 'filter' in wc) wc.filter = 'blur(' + blurPx.toFixed(2) + 'px)';
      wc.drawImage(srcCanvas, 0, 0);
      wc.filter = 'none';
      var id = wc.getImageData(0, 0, w, h), d = id.data, thr = 2.56 * balanceVal;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 128) { // outside-image / transparent → background
          d[i] = d[i + 1] = d[i + 2] = 255; d[i + 3] = transparentBg ? 0 : 255; continue;
        }
        var L = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        if (L >= thr) { d[i] = d[i + 1] = d[i + 2] = 255; d[i + 3] = transparentBg ? 0 : 255; }
        else { d[i] = d[i + 1] = d[i + 2] = 0; d[i + 3] = 255; }
      }
      wc.putImageData(id, 0, 0);
      return work;
    }

    var cropper = null;
    // push the current B/W (white-bg) image into the cropper so the RIGHT pane
    // shows the engraving result live; Cropper.replace(url,true) keeps the crop
    // box, zoom and rotation (the documented "swap to a filtered image" pattern)
    function refreshCropperImage() {
      if (!cropper || !grayscale) return;
      var bw = thresholdCanvas(false);
      if (bw) cropper.replace(bw.toDataURL('image/png'), true);
    }
    // true while a slider change's cropper.replace() image is still decoding —
    // getCroppedCanvas would return a blank crop, which must not overwrite the
    // good jewelry preview (that was the "engraving disappears" bug)
    function cropIsBlank(cnv) {
      try {
        var d = cnv.getContext('2d').getImageData(0, 0, cnv.width, cnv.height).data;
        for (var i = 3; i < d.length; i += 4 * 97) { if (d[i] > 0) return false; }
        return true;
      } catch (e) { return false; }
    }
    // LEFT jewelry preview: composite the crop with a TRANSPARENT background so
    // only the brown strokes sit on the metal
    function renderLeft() {
      if (!cropper) return;
      var crop = cropper.getCroppedCanvas({ maxWidth: 1000, maxHeight: 1000 });
      if (!crop || cropIsBlank(crop)) return; // mid-replace decode → keep the current preview
      var out = grayscale ? whiteToTransparent(crop, engraveColor()) : crop;
      out._mcFld = fld; // live crop preview replaces THIS field's stored crop
      ensureBaseImage(currentBase(), function (img) { paintScene(leftCtx, img, out); });
    }
    var leftTimer = null;
    function scheduleLeft() { clearTimeout(leftTimer); leftTimer = setTimeout(renderLeft, 120); }
    var sliderTimer = null;
    function scheduleSlider() {
      clearTimeout(sliderTimer);
      sliderTimer = setTimeout(function () {
        refreshCropperImage();      // swaps the cropper image (async decode)
        // re-render the jewelry preview as the new image decodes; cropIsBlank
        // skips the early (still-decoding) attempts so it never blanks out
        renderLeft();
        setTimeout(renderLeft, 90);
        setTimeout(renderLeft, 240);
      }, 130);
    }

    function close() {
      if (cropper) { try { cropper.destroy(); } catch (e) {} }
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.classList.remove('mc-crop-open');
      try { URL.revokeObjectURL(objURL); } catch (e) {}
    }

    function confirmCrop() {
      if (!cropper) { close(); return; }
      // the cropper already holds the B/W (white-bg) image → its crop IS the engraving
      var crop = cropper.getCroppedCanvas({ maxWidth: 1400, maxHeight: 1400 });
      if (!crop) { close(); return; }
      // on-page jewelry preview: brown strokes on transparent (matches the text)
      state.cropImage = grayscale ? whiteToTransparent(crop, engraveColor()) : crop;
      state.cropImage._mcFld = fld;
      fld._cropImage = state.cropImage;
      // _Billede_crop for the engraver: flatten onto solid white so any
      // transparent (zoomed-out) margins become white → clean black-on-white
      var exp = crop;
      if (grayscale) {
        exp = document.createElement('canvas'); exp.width = crop.width; exp.height = crop.height;
        var ec = exp.getContext('2d');
        ec.fillStyle = '#fff'; ec.fillRect(0, 0, exp.width, exp.height);
        ec.drawImage(crop, 0, 0);
      }
      exp.toBlob(function (blob) {
        if (blob) {
          state.cropBlob = blob;
          // _Billede_crop = cropped PNG file (Zepto names it <field>_cropped_image.png);
          // the ORIGINAL upload stays on properties[Billede] (the file input)
          setFileInput(cropInput, blob, (v.prop || 'Billede') + '_cropped_image.png', 'image/png');
        }
        close();
        render(); validate();
      }, 'image/png');
    }

    // engraving sliders in the personalizer look — Balance on top, Smoothness below
    if (sliders) {
      function sliderRow(cls, label, min, max, val, onChange) {
        var row = el('div', 'mc-crop-slider ' + cls, sliders);
        var lab = el('label', 'mc-crop-slider-lab', row); lab.textContent = label;
        var inp = el('input', 'mc-crop-range', row);
        inp.type = 'range'; inp.min = min; inp.max = max; inp.step = 1; inp.value = val;
        var out = el('span', 'mc-crop-slider-val', row); out.textContent = val;
        inp.addEventListener('input', function () {
          out.textContent = inp.value;
          onChange(parseInt(inp.value, 10));
          scheduleSlider();
        });
        return inp;
      }
      sliderRow('mc-crop-balance', t('cropBalance', 'Balance'), 0, 100, balanceVal, function (n) { balanceVal = n; });
      sliderRow('mc-crop-smooth', t('cropSmooth', 'Udjævning'), 0, 100, smoothVal, function (n) { smoothVal = n; });
    }

    function del() {
      state.uploadFile = null; state.cropImage = null; state.cropBlob = null;
    fields.forEach(function (f) { f._uploadFile = null; f._cropImage = null; });
      fld._uploadFile = null; fld._cropImage = null;
      try { cropInput.value = ''; } catch (e) {}
      var fileIn = v._fileInput;
      if (fileIn) { try { fileIn.value = ''; } catch (e) {} }
      close();
      render(); validate();
    }

    // toolbar (display order matches Zepto: delete, rotate CW, rotate CCW, zoom out, zoom in, confirm)
    function tool(cls, title, svg, onClick) {
      var b = el('button', 'mc-crop-tool ' + cls, bar);
      b.type = 'button';
      b.title = title;
      b.setAttribute('aria-label', title);
      b.innerHTML = svg;
      b.addEventListener('click', function (e) { e.preventDefault(); onClick(); });
      return b;
    }
    var ICON = {
      trash: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
      rotcw: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>',
      rotccw: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>',
      minus: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      plus: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      check: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
    };
    tool('mc-crop-del', t('cropDelete', 'Fjern billede'), ICON.trash, del);
    tool('mc-crop-rot', t('cropRotate', 'Rotér'), ICON.rotcw, function () { if (cropper) cropper.rotate(90); });
    tool('mc-crop-rot', t('cropRotate', 'Rotér'), ICON.rotccw, function () { if (cropper) cropper.rotate(-90); });
    tool('mc-crop-zoom', t('cropZoomOut', 'Zoom ud'), ICON.minus, function () { if (cropper) cropper.zoom(-0.1); });
    tool('mc-crop-zoom', t('cropZoomIn', 'Zoom ind'), ICON.plus, function () { if (cropper) cropper.zoom(0.1); });
    tool('mc-crop-ok', t('cropConfirm', 'Bekræft'), ICON.check, confirmCrop);

    function initCropper() {
      loadCropperLib(function () {
        cropper = new window.Cropper(cropImg, {
          aspectRatio: aspect,          // col4/col14 — matches the pendant engraving box
          viewMode: 0,                  // 0 = unrestricted: allows zooming OUT past the
                                        // image so tall photos fit fully in the field
          autoCropArea: 1,              // start covering the whole image
          minCropBoxWidth: 50,
          minCropBoxHeight: 50,
          minCanvasWidth: 0, minCanvasHeight: 0,
          rotatable: true, scalable: true, movable: true, zoomable: true,
          checkOrientation: true,       // honour EXIF
          guides: true, center: true,   // rule-of-thirds grid + centre marker
          background: false, responsive: true, // no checkerboard — white behind
          crop: scheduleLeft,
          ready: renderLeft
        });
      });
    }

    // load the original, build a capped colour source, then start the cropper on
    // the B/W (engraving) image so the RIGHT pane shows black-on-white immediately
    var origImg = new Image();
    origImg.onload = function () {
      var cap = 1400;
      var s = Math.min(1, cap / Math.max(origImg.naturalWidth, origImg.naturalHeight));
      var sw = Math.max(1, Math.round(origImg.naturalWidth * s));
      var sh = Math.max(1, Math.round(origImg.naturalHeight * s));
      srcCanvas = document.createElement('canvas'); srcCanvas.width = sw; srcCanvas.height = sh;
      srcCanvas.getContext('2d').drawImage(origImg, 0, 0, sw, sh);
      cropImg.src = grayscale
        ? thresholdCanvas(false).toDataURL('image/png')  // start black-on-white
        : srcCanvas.toDataURL('image/png');
      initCropper();
    };
    origImg.onerror = function () { cropImg.src = objURL; initCropper(); };
    origImg.src = objURL;
  }

  function setFileInput(input, blob, filename, type) {
    try {
      var f = new File([blob], filename, { type: type });
      var dt = new DataTransfer();
      dt.items.add(f);
      input.files = dt.files;
    } catch (e) { /* older Safari: fall back to no crop file */ }
  }

  /* ---------- "order without engraving" opt-in ---------- */
  // Shown in place of the old required-field error the first time a customer
  // tries to add an un-engraved product to the cart. Ticking it satisfies every
  // field requirement; typing an engraving or attaching a drawing unticks it
  // again, so the two choices can never both ride on one line item.
  var noEngBox = null, noEngCb = null;

  function buildNoEngravingAsk() {
    noEngBox = el('div', 'mc-noeng');
    // directly under the engraving fields, above the mobile "Se dit smykke"
    // link — so the question sits between the empty field and Add to cart
    if (previewBtn && previewBtn.parentElement === root) root.insertBefore(noEngBox, previewBtn);
    else root.appendChild(noEngBox);
    el('p', 'mc-noeng-q', noEngBox).textContent = MC_NOENG.ask;
    // NOT a <label> and NOT a native checkbox face: the theme hides every label
    // inside #add-to-cart-form (its variant-label rule) and sets
    // appearance:none on all checkboxes, so both would render invisible. A div
    // row + a real (visually hidden) input + our own box keeps click, keyboard
    // and screen-reader behaviour while owning the looks.
    var row = el('div', 'mc-noeng-row', noEngBox);
    noEngCb = el('input', 'mc-noeng-cb', row);
    noEngCb.type = 'checkbox';
    // deliberately NO name attribute: an unticked box must not be able to post
    // anything. The line-item property is assembled in applyNoEngravingProps().
    noEngCb.setAttribute('aria-label', MC_NOENG.label);
    var face = el('span', 'mc-noeng-box', row);
    face.setAttribute('aria-hidden', 'true');
    face.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    el('span', 'mc-noeng-lab', row).textContent = MC_NOENG.label;
    el('p', 'mc-noeng-done', noEngBox).textContent = MC_NOENG.done;
    noEngCb.addEventListener('change', function () { setNoEngraving(noEngCb.checked); });
    row.addEventListener('click', function (ev) {
      if (ev.target === noEngCb) return; // the input's own change event handles it
      ev.preventDefault();
      noEngCb.checked = !noEngCb.checked;
      setNoEngraving(noEngCb.checked);
    });
  }

  function showNoEngravingAsk() {
    if (!root) return;
    if (!noEngBox) buildNoEngravingAsk();
    noEngBox.style.display = '';
    // 'nearest' so a customer already looking at the checkbox isn't yanked
    try { noEngBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }

  function setNoEngraving(on) {
    on = !!on;
    if (state.noEngraving === on) return;
    state.noEngraving = on;
    if (noEngCb) noEngCb.checked = on;
    if (noEngBox) noEngBox.classList.toggle('mc-noeng-on', on);
    // opting out clears the empty-field highlight — nothing is wrong any more
    if (on && root) root.classList.remove('mc-show-required');
    validate();
  }

  function resetNoEngraving() {
    setNoEngraving(false);
    if (noEngBox) noEngBox.style.display = 'none';
  }

  // Every personalizer input is silenced (disabled inputs post nothing, exactly
  // like hidden conditional fields) and replaced by one customer-facing property
  // plus the hidden marker. The preview PNG and its _pplr_preview marker are
  // deliberately LEFT ENABLED (Jonas 2026-08-01): these orders carry a snapshot
  // of the plain piece like every other order — see noEngravingSnapshot().
  function applyNoEngravingProps() {
    root.querySelectorAll('input, textarea, select').forEach(function (n) {
      if (n.name && n.name.indexOf('properties[') === 0) n.disabled = true;
    });
    var visible = form.querySelector('input[data-mc-noeng-prop]');
    if (!visible) {
      visible = el('input', null, form);
      visible.type = 'hidden';
      visible.setAttribute('data-mc-noeng-prop', '1');
    }
    visible.disabled = false;
    visible.name = 'properties[' + MC_KEYS.text + ']';
    visible.value = MC_NOENG.value;
    var flag = form.querySelector('input[data-mc-noeng-flag]');
    if (!flag) {
      flag = el('input', null, form);
      flag.type = 'hidden';
      flag.setAttribute('data-mc-noeng-flag', '1');
    }
    flag.disabled = false;
    flag.name = 'properties[_No engraving]';
    flag.value = 'true';
  }

  // Snapshot for a no-engraving order: the BARE jewelry photo. It must be
  // rendered fresh with skipText — the on-page canvas paints the grey ghost
  // placeholder ('ABC' etc.) whenever the field is empty, and that would reach
  // the engraver looking like a real engraving.
  function noEngravingSnapshot(cb) {
    var snap = document.createElement('canvas');
    snap.width = snap.height = CANVAS;
    var sc = snap.getContext('2d');
    var done = false;
    var emit = function () {
      if (done) return;
      done = true;
      // JPEG has no alpha: paint white UNDER whatever landed, in case a base
      // photo is missing or carries transparency (transparent → black otherwise)
      sc.setTransform(1, 0, 0, 1, 0, 0);
      sc.globalCompositeOperation = 'destination-over';
      sc.fillStyle = '#fff';
      sc.fillRect(0, 0, snap.width, snap.height);
      sc.globalCompositeOperation = 'source-over';
      snap.toBlob(function (blob) { cb(blob); }, 'image/jpeg', 0.85);
    };
    // never hang the add-to-cart on a slow/failed photo fetch
    var bail = setTimeout(emit, 2500);
    try {
      ensureBaseImage(currentBase(), function (bimg) {
        clearTimeout(bail);
        try { paintScene(sc, bimg, null, true); } catch (e) {}
        emit();
      });
    } catch (e) { clearTimeout(bail); emit(); }
  }

  // 3.82: undo what an earlier add-to-cart (or the theme's tab script) did to
  // the form before building a new one: the 'Uden gravering' inputs and the
  // disabled fields survived the Back button, and adev.js change_input('')
  // blanks the hidden font / placement inputs on every tab click.
  function restoreFormInputs() {
    if (!root || !form) return;
    form.querySelectorAll('input[data-mc-noeng-prop], input[data-mc-noeng-flag]').forEach(function (n) { n.disabled = true; });
    root.querySelectorAll('input, textarea, select').forEach(function (n) {
      if (n.name && n.name.indexOf('properties[') === 0) n.disabled = false;
    });
    fields.forEach(function (f) {
      if (f._fontInput && f.fontOptions && f._fontInput.value === '') {
        var o = f.fontOptions[state.fontChoice[f.prop] || 0];
        if (o) f._fontInput.value = o.name;
      }
      if (f.kind === 'select' && f._wrap && state.selects && state.selects[f.prop] != null) {
        var hs = f._wrap.querySelector('input.pplr_select');
        if (hs && !hs.value) hs.value = state.selects[f.prop];
      }
    });
    applyConditions(); // re-disables inactive conditional fields, renames font keys
    var hw = root.classList.contains('mc-hw');
    fields.forEach(function (f) {
      if (f.kind !== 'upload' || !f._wrap) return;
      var fi = f._wrap.querySelector('input[type="file"]');
      if (fi) fi.disabled = !hw;
    });
  }

  /* ---------- ATC gating + submit ---------- */
  var atcBtn = null;
  function validate() {
    if (!form) return true;
    atcBtn = atcBtn || form.querySelector('button[type="submit"], [name="add"]');
    var ok = true;
    // Photo-only orders are valid on upload products (Zepto order #25086 has an
    // image and no text) — an attached upload satisfies the requirement.
    // When the theme's Håndskrift tab is active (form.adev_handwritting_active,
    // set by adev.js), the photo IS the requirement and text is optional.
    var hasUpload = !!state.uploadFile;
    fields.forEach(function (f) { if (f._uploadFile) hasUpload = true; });
    var handwritingMode = form && form.classList.contains('adev_handwritting_active');
    if (state.noEngraving) {
      ok = true; // opted out of engraving — no field is required
    } else if (handwritingMode) {
      if (!hasUpload) ok = false;
    } else {
      fields.forEach(function (f) {
        if (f.kind === 'text' && f.variants[0].state23 === '1' && f._active !== false) {
          // required text field (Zepto cstmfy_c_required behavior); a wrapper the
          // theme tabs have hidden doesn't count
          if (f._wrap && f._wrap.offsetParent === null) return;
          if (!(state.values[f.prop] || '').trim() && !hasUpload) ok = false;
        }
      });
    }
    if (ok && root) {
      root.classList.remove('mc-show-required');
      var m0 = root.querySelector('.mc-required-msg');
      if (m0) m0.remove();
    }
    if (atcBtn) {
      atcBtn.classList.toggle('mc-atc-blocked', !ok);
      atcBtn.disabled = false; // keep clickable; block in submit handler with message
    }
    return ok;
  }

  function hookSubmit() {
    if (!form) return;
    // preview PNG + marker inputs
    var pv = el('input', 'mc-preview-file', form);
    pv.type = 'file';
    pv.name = 'properties[' + t('previewProp', MC_KEYS.preview) + ']';
    pv.style.display = 'none';
    pv.tabIndex = -1;
    var marker = el('input', null, form);
    marker.type = 'hidden';
    marker.name = 'properties[_pplr_preview]';
    marker.value = t('previewProp', MC_KEYS.preview);

    var mcSubmitting = false;
    var mcBusy = false; // 3.82: one add-to-cart at a time (double Enter/tap)
    function showSubmitError() {
      if (!root) return;
      var old = root.querySelector('.mc-submit-error');
      if (old) old.remove();
      var m = el('p', 'mc-required-msg mc-submit-error', root);
      m.setAttribute('role', 'alert');
      m.textContent = MC_MSG.failed;
    }
    function showAtcOverlay() {
      var ov = el('div', 'poverlay-bg addtocartbg mc-atc-overlay', document.body);
      var box = el('div', 'mc-atc-box', ov);
      // the customer's personalized preview on top of the loading state —
      // something to admire while the multipart POST runs (Jonas 2026-07-06).
      // MUST NOT depend on the mounted gallery canvas: on slow connections a
      // fast tap beats the mount-polling and previewCanvas is still null
      // (looked font-dependent — picking Elegant merely bought mount time).
      // Fallback paints an offscreen snapshot and fills the img in async.
      // a CANVAS, not an <img>: a data-URL image needs an async decode that
      // Safari starves once the multipart submit/navigation starts — with
      // height:auto the box collapsed to 0px and mobile customers never saw
      // the preview (Jonas 2026-07-08, reproduced in WebKit). Canvas pixels
      // paint synchronously and survive until the new page renders.
      var im = el('canvas', 'mc-atc-preview', box);
      im.width = im.height = CANVAS;
      im.style.display = 'none';
      // white-composited (transparent canvas reads as unlit/black otherwise)
      var setSnap = function (cv) {
        try {
          var g2 = im.getContext('2d');
          g2.fillStyle = '#fff';
          g2.fillRect(0, 0, CANVAS, CANVAS);
          g2.drawImage(cv, 0, 0, CANVAS, CANVAS);
          im.style.display = '';
        } catch (e) { /* spinner-only overlay */ }
      };
      // a mounted canvas may still be UNPAINTED (photo not loaded when the
      // customer tapped) — sample alpha before trusting it
      // ...but never trust it without an engraving: it holds the grey ghost
      // placeholder, so fall through to a freshly painted base-only render
      var painted = false;
      if (previewCanvas && !state.noEngraving) {
        try {
          var t2 = document.createElement('canvas');
          t2.width = t2.height = 8;
          var tg = t2.getContext('2d');
          tg.drawImage(previewCanvas, 0, 0, 8, 8);
          var td = tg.getImageData(0, 0, 8, 8).data;
          var opaque = 0;
          for (var ti = 3; ti < td.length; ti += 4) if (td[ti] > 200) opaque++;
          painted = opaque > 16;
        } catch (e) { painted = false; }
      }
      if (painted) {
        setSnap(previewCanvas);
      } else {
        try {
          ensureBaseImage(currentBase(), function (bimg) {
            try {
              var c2 = document.createElement('canvas');
              c2.width = c2.height = CANVAS * previewScale();
              paintScene(c2.getContext('2d'), bimg, null, state.noEngraving);
              setSnap(c2);
            } catch (e) { /* spinner-only overlay */ }
          });
        } catch (e) { /* spinner-only overlay */ }
      }
      el('div', 'mc-atc-spinner', box);
      var txt = el('div', 'mc-atc-text', box);
      txt.textContent = t('pleaseWait', 'Vent venligst');
      setTimeout(function () {
        if (txt.isConnected !== false) txt.textContent = t('addingToCart', 'Tilføjer til kurv');
      }, 1800);
      return ov;
    }

    function runPersonalizedSubmit(e) {
      if (mcSubmitting) return; // our own native submit passing through
      // Block EVERYTHING else first (theme AJAX add drops file fields — the
      // preview PNG and uploads would vanish; testers B/C/E all hit this).
      e.preventDefault();
      e.stopImmediatePropagation();
      if (mcBusy) return;
      restoreFormInputs();
      if (!validate()) {
        // Jonas 2026-08-01: an empty engraving is no longer a dead end. Instead
        // of the red "Udfyld venligst din indgravering" the customer is asked
        // whether they want the piece without engraving. The empty field keeps
        // its highlight so the question is obviously about it, and we do NOT
        // focus the input — that would pop the mobile keyboard over the answer.
        root.classList.add('mc-show-required');
        showNoEngravingAsk();
        return;
      }
      // F6: never rasterize the engraver-facing snapshot before the real faces
      // resolved. Typing normally triggered the load long before ATC; this
      // closes the race (fast tap, prefill) — block once, await fonts + a
      // repaint, then re-enter. Skipped without engraving: no text is drawn, so
      // no face can be missing and the customer waits on nothing.
      if (!fontsReadyDone && !state.noEngraving) {
        if (mcFontWait) return;
        mcFontWait = true;
        ensureFontsLoaded().then(function () {
          if (!TUNE.fontRaceFix) {
            draw();
            setTimeout(function () { mcFontWait = false; runPersonalizedSubmit(e); }, 200);
            return;
          }
          // the snapshot copies the on-page canvas - wait for the actual
          // repaint (incl. the async base-photo fetch), with a hard timeout
          // so a failed fetch can never strand the add-to-cart
          var done = false;
          var go = function () { if (done) return; done = true; mcFontWait = false; runPersonalizedSubmit(e); };
          onDrawComplete(go);
          draw();
          setTimeout(go, 1200);
        });
        return;
      }
      if (mcBusy) return;
      mcBusy = true;
      form.enctype = 'multipart/form-data';
      form.method = 'post';
      // Zepto parity: the ATC button itself stays untouched; feedback is a
      // full-viewport spinner overlay with staged text (live-verified:
      // 'Vent venligst' → 'Tilføjer til kurv', then the page lands on /cart).
      // Also covers the PNG-upload window on slow connections.
      var overlay = showAtcOverlay();
      if (state.noEngraving) {
        applyNoEngravingProps();
      } else {
      syncFontPropNames();
      // Koordinater mode: the theme's map picker mirrors the coordinate string
      // into the hidden font input (legacy Zepto quirk — orders showed
      // '🖊️: 53°15'6" N …' twice). Submit a hidden (_-prefixed) marker instead; the
      // coordinates themselves already ride in the Engraving property.
      fields.forEach(function (f) {
        if (!f._fontInput || !f.fontOptions) return;
        var val = f._fontInput.value;
        var known = f.fontOptions.some(function (o) { return o.name === val; });
        if (val && !known) {
          f._fontInput.name = 'properties[_Engraving type]';
          f._fontInput.value = 'Coordinates';
        }
      });
      // Zepto omits keys for empty personalization fields (photo-only order
      // #25086 has no 'ABC' key at all) — disable empties so they don't post.
      fields.forEach(function (f) {
        if (f.kind !== 'text' || f._active === false || !f._wrap) return;
        var empty = !(state.values[f.prop] || '').trim();
        f._wrap.querySelectorAll('input, textarea').forEach(function (n) {
          if (n.name && n.name.indexOf('properties[') === 0) n.disabled = empty;
        });
      });
      }
      var finish = function () {
        // signal mc-cart.js that an ATC is in flight: the companion line lands
        // BEFORE the main line's multipart POST (PNG upload can take seconds),
        // and must not be cleaned up as an orphan in that window
        try { sessionStorage.setItem('mcAtcPending', String(Date.now())); } catch (e) {}
        maybeAddSurcharge().then(function () {
          if (CFG.dryRun) {
            document.dispatchEvent(new CustomEvent('mc:submit-ready'));
            if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
            mcBusy = false;
            return;
          }
          mcSubmitting = true;
          // Analytics fix 2026-07-18: a programmatic native submit is invisible
          // to Shopify's cart tracking (it patches fetch/XHR and .submit() fires
          // no submit event) — sessions_with_cart_additions flatlined the day
          // this widget replaced Zepto's AJAX add. POST the same multipart
          // payload via fetch to /cart/add.js so the pixel layer sees it, then
          // land on /cart as before. Native submit remains the fallback so ATC
          // itself can never break on a fetch/network failure.
          var fd = null;
          try { fd = new FormData(form); } catch (err) {}
          if (!fd || typeof fetch !== 'function') {
            HTMLFormElement.prototype.submit.call(form); // native multipart POST → /cart
            return;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          }).then(function (r) {
            if (!r.ok) throw new Error('cart/add.js HTTP ' + r.status);
            // A/B dc1: the item is in the cart now — nothing below may reach
            // the .catch (that would POST the item a second time natively)
            mcAbAfterAdd().then(function (dest) { window.location.assign(dest); },
              function () { window.location.assign('/cart'); });
          }).catch(function () {
            HTMLFormElement.prototype.submit.call(form); // pre-fix behavior
          });
        }, function () {
          // 3.82: the handwriting fee could not be added (even after a retry) -
          // stop here instead of selling the drawing without its fee
          mcBusy = false;
          try { sessionStorage.removeItem('mcAtcPending'); } catch (e2) {}
          if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
          showSubmitError();
        });
      };
      if (state.noEngraving) {
        noEngravingSnapshot(function (blob) {
          if (blob) setFileInput(pv, blob, 'preview.jpg', 'image/jpeg');
          finish();
        });
      } else if (previewCanvas) {
        // export at logical size as JPEG (~14KB) instead of the 2x hi-DPI PNG
        // (~380KB): the multipart /cart/add blocks navigation until the file
        // is uploaded AND ingested by Shopify — payload size is the dominant
        // click→cart wait, especially on mobile uplinks
        var snap = document.createElement('canvas');
        snap.width = snap.height = CANVAS;
        var sctx = snap.getContext('2d');
        sctx.fillStyle = '#fff'; // JPEG has no alpha; transparent → white, not black
        sctx.fillRect(0, 0, CANVAS, CANVAS);
        sctx.drawImage(previewCanvas, 0, 0, CANVAS, CANVAS);
        snap.toBlob(function (blob) {
          if (blob) setFileInput(pv, blob, 'preview.jpg', 'image/jpeg');
          finish();
        }, 'image/jpeg', 0.85);
      } else {
        finish();
      }
    }
    // Capture-phase CLICK interception on the ATC button: theme scripts add via
    // AJAX or call form.submit() (which fires no submit event), so hooking only
    // the submit event misses entirely. Document-level capture runs before any
    // theme listener.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('button[type="submit"], [name="add"]');
      if (!btn || !form || !form.contains(btn)) return;
      runPersonalizedSubmit(e);
    }, true);
    // Fallback for keyboard submits / other paths:
    form.addEventListener('submit', function (e) {
      if (!mcSubmitting) runPersonalizedSubmit(e);
    }, true);
    // back-button (bfcache) restore: clear the in-flight state or the next
    // ATC click is silently ignored and the stale overlay covers the page
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        mcSubmitting = false;
        mcBusy = false;
        document.querySelectorAll('.mc-atc-overlay').forEach(function (n) { n.remove(); });
      }
    });
  }

  /* ---------- A/B test dc1: direct to checkout (Claude 2026-10-03) ----------
     Products WITHOUT a backside upsell (no custom.pairs_with_products — the
     cart page has nothing to sell them) skip the cart page in arm B and land
     in checkout. The arm lives on the CART as attribute _mc_ab ("dc1:A" /
     "dc1:B"): sticky per cart, no cookie or localStorage, and it rides into
     the order (customAttributes) for the readout. Switch = shop metafield
     mc_ab.direct_checkout → CFG.abDc.mode: off (default, today's behavior) |
     test (50/50) | B (everyone to checkout, no tagging). QA: ?mc_ab=A or B
     forces an arm for this tab and tags the cart "dc1:A-qa"/"dc1:B-qa", so QA
     carts never enter the stats. The same /cart/update.js also writes
     mc_previews (mc-cart.js normally syncs it on the cart page, which arm B
     skips — abandonment emails need it). Every failure path → '/cart'. */
  var AB_ATTR = '_mc_ab';
  var AB_PREVIEW_KEYS = ['Vis smykke', 'Visa smycket', 'Schmuck ansehen', 'Voir le bijou', 'View jewelry', 'Zobacz biżuterię', 'Bekijk sieraad'];
  function mcAbForced() {
    try {
      var m = /[?&]mc_ab=(A|B)(&|$)/.exec(window.location.search);
      if (m) sessionStorage.setItem('mcAbForce', m[1]);
      return sessionStorage.getItem('mcAbForce');
    } catch (e) { return null; }
  }
  function mcAbPreviews(cart) {
    var urls = [];
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      for (var i = 0; i < AB_PREVIEW_KEYS.length; i++) {
        var u = p[AB_PREVIEW_KEYS[i]];
        if (u && /^https?:\/\//.test(String(u))) {
          if (urls.indexOf(u) < 0) urls.push(u);
          return;
        }
      }
    });
    return urls.join('|');
  }
  function mcAbAfterAdd() {
    try {
      var ab = CFG.abDc;
      if (!ab || !ab.eligible || typeof fetch !== 'function') return Promise.resolve('/cart');
      var forced = mcAbForced();
      if (forced !== 'A' && forced !== 'B') forced = null;
      if (!forced && ab.mode === 'B') return mcMailBeforeCheckout('/checkout');
      if (!forced && ab.mode !== 'test') return Promise.resolve('/cart');
      var test = ab.test || 'dc1';
      var work = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
        .then(function (cart) {
          var attrs = cart.attributes || {};
          var cur = String(attrs[AB_ATTR] || '');
          var m = new RegExp('^' + test + ':(A|B)(-qa)?$').exec(cur);
          var arm = forced || (m ? m[1] : (Math.random() < 0.5 ? 'A' : 'B'));
          var qa = !!forced || !!(m && m[2]);
          var tag = test + ':' + arm + (qa ? '-qa' : '');
          var dest = arm === 'B' ? '/checkout' : '/cart';
          var payload = { attributes: {} };
          if (cur !== tag) payload.attributes[AB_ATTR] = tag;
          var pv = mcAbPreviews(cart);
          if (pv && pv !== String(attrs.mc_previews || '')) payload.attributes.mc_previews = pv;
          // MC 2026-10-27 (3.91): abandonment-mail data (see assets/mc-cart.js mcMailAttr)
          var me = mcMailValue(cart);
          if (me !== null && me !== String(attrs.mc_email || '')) payload.attributes.mc_email = me;
          var done = function () {
            try {
              (window.dataLayer = window.dataLayer || []).push({
                event: 'mc_ab_exposure', mc_ab_test: test, mc_ab_arm: arm, mc_ab_qa: qa
              });
            } catch (e) {}
            return dest;
          };
          if (!Object.keys(payload.attributes).length) return done();
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (r) { if (!r.ok) throw new Error('update.js ' + r.status); return done(); });
        });
      // never strand the customer on the overlay: slow network → today's path
      var timeout = new Promise(function (res) { setTimeout(function () { res('/cart'); }, 3000); });
      return Promise.race([work, timeout]).then(null, function () { return '/cart'; });
    } catch (e) {
      return Promise.resolve('/cart');
    }
  }

  // MC 2026-10-27 (Claude, 3.91): abandonment e-mails read cart attributes only.
  // The direct-to-checkout rollout (mode B) skips the cart page, where mc-cart.js
  // normally writes them, so write mc_previews + mc_email here before leaving.
  function mcMailValue(cart) {
    try {
      return (window.mcMailAttr && !window.__MC_MAIL_OFF) ? window.mcMailAttr.build(cart) : null;
    } catch (e) { return null; }
  }
  function mcMailBeforeCheckout(dest) {
    try {
      var work = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
        .then(function (cart) {
          var attrs = cart.attributes || {};
          var payload = { attributes: {} };
          var pv = mcAbPreviews(cart);
          if (pv && pv !== String(attrs.mc_previews || '')) payload.attributes.mc_previews = pv;
          var me = mcMailValue(cart);
          if (me !== null && me !== String(attrs.mc_email || '')) payload.attributes.mc_email = me;
          if (!Object.keys(payload.attributes).length) return dest;
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function () { return dest; });
        });
      // never strand the customer: slow network -> go on without the attributes
      var timeout = new Promise(function (res) { setTimeout(function () { res(dest); }, 3000); });
      return Promise.race([work, timeout]).then(null, function () { return dest; });
    } catch (e) {
      return Promise.resolve(dest);
    }
  }

  function maybeAddSurcharge() {
    // Handwriting/photo upload adds companion line 'Hånskrift / Tegning'.
    // Quantity comes from the config (Zepto: 200 kr = qty 2 × 100 kr variant —
    // real order #25086 has qty_split '…-2'). Undercharging = lost revenue.
    var anyUpload = !!state.uploadFile;
    fields.forEach(function (f) { if (f._uploadFile) anyUpload = true; });
    if (!CFG.surcharge || !anyUpload) return Promise.resolve();
    var qty = CFG.surcharge.qty || 1;
    var ref = String(Math.floor(Math.random() * 900000000) + 100000000);
    // 3.82: a retry after Back must not leave a second, stale ref in the form
    form.querySelectorAll('input[name="properties[_pc_pricing_ref]"], input[name="properties[_pc_pricing_qty_split]"]').forEach(function (n) { n.remove(); });
    var refIn = el('input', null, form); refIn.type = 'hidden';
    refIn.name = 'properties[_pc_pricing_ref]'; refIn.value = ref;
    var qsIn = el('input', null, form); qsIn.type = 'hidden';
    qsIn.name = 'properties[_pc_pricing_qty_split]';
    qsIn.value = CFG.surcharge.variantId + '-' + qty;
    var addFee = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: CFG.surcharge.variantId, quantity: qty,
          properties: { _pc_pricing_ref: ref }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('surcharge HTTP ' + r.status);
        return r.json();
      });
    };
    // 3.82: errors used to be swallowed, so the drawing could be added without
    // its fee. One retry, then the add-to-cart stops with a message.
    return addFee().catch(function () {
      return new Promise(function (res) { setTimeout(res, 800); }).then(addFee);
    }).catch(function (err) {
      refIn.remove(); qsIn.remove();
      throw err;
    });
  }

  /* ---------- per-product design overrides (merchant tuning) ----------
     The config asset may carry an "overrides" object to adjust rendering per
     field WITHOUT touching the migrated Zepto CSV metas:
       "overrides": { "'ABC'": { "size": 18, "x": 50, "y": 42, "w": 25,
                                  "color": "#8c603b", "spacing": -1900 } }
     Keys: size (base pt, Zepto pss scale) · x/y (% of canvas) · w (box width %,
     drives shrink-to-fit) · ratio (box HEIGHT %) · color · spacing (arc:
     negative=inward) · lineHeight · maxLines · maxChars.
     Preferred workflow: docs/config-editor.html (visual editor) → export JSON →
     Claude Code merges it into mc-configs-all.json and deploys. */
  function applyOverrides() {
    var ov = CFG.overrides;
    if (!ov) return;
    fields.forEach(function (f) {
      var o = ov[f.prop];
      if (!o) return;
      f.variants.forEach(function (v) {
        ['size', 'x', 'y', 'w', 'ratio', 'color', 'spacing', 'lineHeight',
         'maxLines', 'maxChars'].forEach(function (k) {
          if (o[k] !== undefined) v[k] = o[k];
        });
        // explicit spacing override = merchant wants the arc even on a
        // plain-type (col10 ≤ 2) field where Zepto would ignore col5
        if (o.spacing !== undefined) v._spacingForced = true;
      });
    });
  }

  /* ---------- boot ---------- */
  function init() {
    if (!CFG.metas || !CFG.metas.length) return;
    applyOverrides();
    // F6: UI builds immediately; faces load on first engagement. Prefilled
    // content (bfcache restore, autofill, test harnesses) loads them right away.
    try { buildUI(); } catch (e) {
      if (window.console) console.error('[mc-personalizer]', e);
    }
    // Fonts kick off at BOOT (post-DOMContentLoaded) — NOT via the old <head>
    // preloads (they competed with the LCP image) and NOT via interaction
    // triggers (touchstart fires at scroll-gesture start; loading mid-scroll
    // caused the iOS scroll-stick, 2026-07-19). Boot-loading matches 3.1's
    // proven-smooth behavior: the chips/input pick up their real faces via
    // applyDomFonts a moment after load, and the draw/submit gates still
    // guarantee no preview or engraver snapshot ever renders in a fallback.
    ensureFontsLoaded();
  }
  function boot() {
    if (CFG.metas && CFG.metas.length) { init(); return; }
    // No inline config → try theme-asset config (mc-config-<productId>.json).
    // 404 = product not personalized; widget stays inert.
    if (!CFG.productId || !CFG.assetBase) return;
    // single combined config asset; prefer the versioned URL (asset_url ?v=)
    // so config redeploys bust the CDN edge cache immediately
    fetch(CFG.configUrl || (CFG.assetBase + 'mc-configs-all.json'))
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (all) {
        var c = all[String(CFG.productId)];
        if (!c) throw 0;
        return c;
      })
      .then(function (cfg) {
        CFG.metas = cfg.metas || [];
        CFG.canvasSize = cfg.canvas || CFG.canvasSize;
        CFG.prodata = cfg.prodata || CFG.prodata;
        CFG.fontGroups = cfg.fontGroups || CFG.fontGroups;
        CFG.dropdowns = cfg.dropdowns || CFG.dropdowns;
        CFG.overrides = cfg.overrides || CFG.overrides; // editor-pipeline tuning (applyOverrides)
        if (cfg.surchargeVariantId) CFG.surcharge = { variantId: cfg.surchargeVariantId, qty: cfg.surchargeQty || 1 };
        FONT_GROUP = (CFG.fontGroups && (CFG.fontGroups.FONTS || CFG.fontGroups.Skrifttype)) || FONT_GROUP;
        fields = buildFields(CFG.metas.map(decodeMeta));
        CANVAS = CFG.canvasSize || 600;
        init();
      })
      .catch(function () { /* not a personalized product */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
